export const langTh = {
  title: 'ยินดีต้อนรับ {{name}} สู่ขุนทอง v3.0.1',
  // description: {
  //   part1: '#ขุนทอง',
  //   part2: '',
  // },
  common: {
    bahtSymbol: '฿',
    baht: 'บาท',
  },
  date: {
    sunday: 'อาทิตย์',
    monday: 'จันทร์',
    tuesday: 'อังคาร',
    wednesday: 'พุธ',
    thursday: 'พฤหัสฯ',
    friday: 'ศุกร์',
    saturday: 'เสาร์',
  },
  message: {
    formValidateMsg: {
      isRequired: 'กรุณากรอกข้อมูล',
      //isMax: 'จำนวนต้องน้อยว่าหรือเท่ากับ',
      //isMin: 'จำนวนต้องมากกว่าหรือเท่ากับ',
      isNotEmailFormat: 'รูปแบบอีเมล์ไม่ถูกต้อง',
      //isNumber: 'จำนวนตัวเลขไม่ถูกต้อง',
      isInvalidPassword: 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร',
      isIdCard: 'กรุณากรอกเลขบัตรประชน 13 หลัก',
      isPhone: 'กรุณากรอกหมายเลขโทรศัพท์ 10 หลัก',
      isPwdNotMatch: 'กรุณาระบุรหัสผ่านให้ตรงกัน',
      isMemberEmpty: 'กรุณาเลือกสมาชิก',
      isDummyEmpty: 'กรุณาเลือกเพื่อนที่พามา',

      //isMemberEmptyNotAllow: 'จำนวนสมาชิกต้องมีอย่างน้อย 1 คน',
      priceLessThanOrEqualZero:
        'มีบางรายการราคาน้อยกว่าหรือเท่ากับ 0 กรุณาตรวจสอบอีกครั้ง',
      itemNameRequired: 'กรุณาใส่ชื่อและราคาให้ครบทุกรายการ',
      billNameIsRequired: 'กรุณาระบุชื่อบิล',
      billImageIsRequired: 'กรุณาเลือกรูปภาพบิล',
      billTotalIsOverLimit: 'ยอดรวมบิล ไม่สามารถมากกว่า {{limit}} น้าา~',
      billTotalIsLessThanZero: 'ยอดรวมบิล ต้องมากกว่า 0 กรุณาตรวจสอบอีกครั้ง',
      billMustHaveItem: 'ต้องมีรายการอย่างน้อย 1 รายการ',
      wrongIdCard: 'เลขบัตรประชาชนไม่ถูกต้อง',
      transferAmountIsOverLimit: 'การโอนเงิน ไม่สามารถมากกว่า {{limit}} น้าา~',
    },
    responseMsg: {
      //saveSuccess: 'บันทึกสำเร็จ',
      saveFailed: 'ไม่สามารถบันทึกได้',
      saveFailedReason: 'ไม่สามารถบันทึกได้ เนื่องจาก',
      loadFailed: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
      loadImageFailed: 'ไม่สามารถโหลดรูปภาพได้',
      ownerMismatch: 'ใบเสร็จนี้...ไม่ใช่ของคุณพี่ ไม่สามารถดำเนินการได้จ้าา~',
      userMismatch: 'คุณไม่ได้ถูกเลือกในรายการนี้ ไม่สามารถดำเนินการได้',
      selectAccount: 'กรุณาเลือกช่องทางการชำระเงิน ที่ต้องการชำระจ้า',
      duplicateBill: 'ใบเสร็จนี้ถูกสร้างไปแล้วนะ...',
      billCanceled: 'ขออภัย! รายการนี้ได้จ่ายหรือถูกยกเลิกแล้ว',
      billCanceledPopup: 'ขออภัย!<br/>รายการนี้ได้จ่ายหรือถูกยกเลิกแล้ว',
      billNotComplete: 'บิลเก่ายังไม่เรียบร้อยเลยน้าา~',
      maxBillsInGroup:
        'กลุ่มพี่สร้างบิลเต็มจำนวนสูงสุด {{maxBillsInGroup}} บิลแล้ว ถ้าพี่จะสร้างบิลเพิ่ม ช่วยปิดบิลเก่าๆก่อนนะค้าบบ',
      loadSlipFailed: 'ไม่สามารถดาวน์โหลดสลิปได้ กรุณาลองใหม่อีกครั้ง',
      requestNotCompleted: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง',
      internalServerError: 'ขออภัย เกิดข้อผิดพลาดกรุณาทำรายการใหม่น้าา~',
      permissionDenied: 'คุณไม่มีสิทธิ์เข้าถึง',
      notSupportBrowser: 'ขออภัย กรุณาเปิดใน LINE ของมือถือน้าา~',
      scheduleDuplicate: 'รายการเก็บรายเดือนนี้ สร้างไปแล้วนะ...',
      scheduleOwnerMismatch:
        'รายการเก็บรายเดือนนี้...ไม่ใช่ของคุณพี่ ไม่สามารถดำเนินการได้จ้าาาา',
      update_line: 'กรุณาอัพเดท LINE เพื่อใช้งาน',
      location_denied:
        'ไม่สามารถอ่านตำแหน่งที่อยู่ปัจจุบันได้ กรุณาอนุญาตให้ LINE เข้าถึงตำแหน่งที่อยู่ปัจจุบันของคุณ',
      pleaseAddKhunthong: 'กรุณาเพิ่มขุนทองเป็นเพื่อนก่อน',
      verifyingLineAccount: '...กำลังค้นหา LINE Account...',
      pleaseReopenThisWindow: '...กรุณาลองเข้าใหม่อีกครั้ง...',
      pleaseSwapInternet:
        'กรุณาปิด Wifi หรือ เปลี่ยนสัญญาณ Internet เพื่อทำรายการใหม่',
    },
    confirmMsg: {
      //title: 'ยืนยัน',
      //deleteItem: 'คุณต้องการลบรายการนี้หรือไม่ ?',
      billCanceled: 'คุณยืนยันการยกเลิกบิลนี้หรือไม่ ?',
      //billCreated: 'คุณยืนยันการสร้างบิลนี้ต่อหรือไม่ ?',
      continueDo: 'คุณยืนยันการทำรายการนี้ต่อหรือไม่ ?',
      //confirm: 'คุณยืนยันการ{{text}}นี้ต่อหรือไม่ ?',
    },
    common: {
      //billName: 'บิล ',
      deleteLimit: 'ไม่สามารถลบได้ ต้องมีรายการอย่างน้อย 1 รายการ',
      deleteUnable: 'ไม่สามารถลบได้',
      //noItem: 'ไม่สามารถ หารายการได้',
      //next: 'ต่อไป',
      select: 'เลือก',
      confirm: 'ยืนยัน',
      confirmYes: 'ยืนยัน',
      copy: 'คัดลอกเลขบัญชี',
      copy2: 'คัดลอก',
      copySuccess: ' คัดลอกสำเร็จ!',
      copySuccessDesc: 'กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนทำรายการ',
      sentSlip: 'บันทึกสลิปสำเร็จ!',
      currency: 'บาท',
      save: 'บันทึก',
      cancel: 'ยกเลิก',
      btnYes: 'ตกลง',
      btnNo: 'ยกเลิก',
      btnOkay: 'ตกลง',
      btnLinkAccount: 'ผูกบัญชี',
      btnConfirmDelete: 'ยืนยันการลบ',
      btnBack: 'ย้อนกลับ',
      close: 'ปิด',
    },
    Remark: {
      actualTotal: 'จำนวนเงินถูกปรับจาก {{total}} บาท เพื่อให้หารลงตัว',
      changedTotal: 'จำนวนเงินถูกปรับเป็น {{total}} บาท เพื่อให้หารลงตัว',
    },
    error: {
      duplicateMobileNo:
        '<b>ขออภัย! หมายเลขโทรศัพท์นี้<br/>เคยถูกใช้ลงทะเบียนแล้ว</b><br/><br/>กรุณายกเลิกการผูกบัญชีของคุณกับ LINE Account อื่นก่อน หรือสอบถามข้อมูลเพิ่มเติม<br/>ติดต่อ 02-888-8888 ต่อ 800',
    },
  },
  cropImage: {
    cropButton: 'ครอปรายการที่เก็บเงิน',
    textLoader: 'Crop เฉพาะรายการที่จะหาร',
    textLoader2: 'ไม่ต้องคร้อป Tax, VAT, Discount',
    textLoader3: 'จะมีช่องให้ใส่ภายหลังน้าา~',
    error: {
      canReadSomeItem:
        '<b>น้องยังอ่านไม่ค่อยเก่ง</b></br>พี่กรุณาตรวจสอบข้อมูลด้วยน้าา~',
      cannotReadItem:
        '<b>อ่านไม่ออก ขุนทองขอโทษน้าา~</b></br>ช่วยใส่ข้อมูลบนใบเสร็จให้หน่อย',
    },
    cropBtn: 'Crop ใหม่',
    manualBtn: 'ใส่ข้อมูลเอง',
    //nextBtn: 'ต่อไป',
    okayBtn: 'ตกลง',
    stickyContent: {
      selectImage: 'เลือกรูปภาพ',
      cropAnotherImage: 'เลือกรูปอื่น',
      rotateImage: 'หมุนภาพ',
    },
    uploadReceiptImage: 'อัพโหลดรูปใบเสร็จ',
    pleaseClickUploadReceipt: 'กด "เลือกรูปภาพ" เพื่ออัพโหลดรูปใบเสร็จ',
  },
  cropImageTutorial: {
    title: 'Crop เฉพาะรายการที่จะหาร',
    subtitle: 'ไม่ต้องคร้อป Tax, Vat, Discount',
    subtitle2: 'จะมีช่องให้ใส่ภายหลังน้าา~',
    btnOk: 'เริ่มกันเลย',
  },
  testcahce: {
    title: '',
    pleaseSelectBank: 'กรุณาเลือกธนาคาร',
  },
  addBankAccountPage: {
    title: 'เลือกบัญชีรับเงิน',
    promptPayCode: 'รหัสพร้อมเพย์',
    selectBank: 'บัญชีธนาคาร',
    accountNo: 'เลขบัญชี',
    accountName: 'ชื่อบัญชี',
    bankAccount: 'บัญชีธนาคาร',
    promptPay: 'พร้อมเพย์',
    nextBtn: 'ต่อไป',
    confirmButton: 'ยืนยัน',
    linkAccountDialogTitle: 'มีบัญชีที่ผูกไว้กับขุนทอง',
    useAnotherAccount: 'ใช้บัญชีอื่น',
    linkAccKplus: 'ใช้เป็นบัญชีรับเงิน',
    pleaseSelectBank: 'กรุณาเลือกธนาคาร',
    kasikornbank: 'ธ.กสิกรไทย',
    exposedInfoWhenTransfer:
      'ข้อมูลนี้เป็นข้อมูลที่เพื่อนคุณจะเห็นเมื่อโอนเงินให้',
    error: {
      followTag: 'ตาม @{{displayName}} มา กรอกบัญชีรับเงินด้วยจ้า~',
      accountWrong: 'เกิดข้อผิดพลาด หรือ บัญชีรับเงินไม่ถูกต้อง',
      bankWrong: 'กรุณาเลือกธนาคาร',
      requireBankName: 'กรุณากรอกชื่อบัญชี',
      requireBankNo: 'กรุณากรอกเลขบัญชี {{digits}} หลัก',
      requirePromptpayName: 'กรุณากรอกชื่อบัญชี',
      requirePromptpayNo:
        'กรุณากรอกเบอร์มือถือ 10 หลัก หรือเลขบัตรประชาชน 13 หลัก',
      wrongIdCard: 'เลขบัตรประชาชนไม่ถูกต้อง',
    },
    warning: {
      //fillAccount: 'กรอกบัญชีรับเงินก่อนนะครับ',
      fillBankCode: 'เลือกบัญชีธนาคารก่อนนะครับ',
    },
    placeholder: {
      specificAccount: 'ระบุเบอร์มือถือ/เลขบัตรประชาชน',
      fillAccountNo: 'กรอกเลขบัญชี',
      fillAccountName: 'กรอกชื่อ-นามสกุล',
    },
  },
  confirmAddAccountPage: {
    title: 'บัญชีคุณ {{name}}',
    promptpay: 'พร้อมเพย์',
    warningMsg: 'กรุณาตรวจสอบข้อมูลของคุณก่อนกดบันทึกบัญชีที่ใช้รับเงิน',
    check: 'ยอมรับข้อกำหนดและเงื่อนไขการใช้บริการ',
    seemore: 'อ่านรายละเอียดเพิ่มเติม',
  },
  createBillPage: {
    account: 'บัญชีรับเงิน:',
    addAccount: 'เพิ่มบัญชี หรือพร้อมเพย์',
    addItem: 'เพิ่มรายการ',
    warning: 'คุณยังไม่ได้เลือกบัญชีรับเงิน',
    warningButton: 'เพิ่มบัญชีรับเงิน',
    erorMsg: 'ข้อมูลบางอย่างไม่ถูกต้อง',
    billTotal: 'ยอดรวมบิล',
    billName: 'ใส่ชื่อบิลที่นี่',
    promptpay: 'พร้อมเพย์',
    memberListHeader: 'ยอดแต่ละคน',
    nextButton: 'ส่งบิลเข้ากลุ่ม',
    nextPageTitle: 'เก็บเงินใครบ้าง',
    deleteItem: 'คุณต้องการลบรายการนี้หรือไม่ ?',
    isMemberEmptyNotAllow: 'จำนวนสมาชิกต้องมีอย่างน้อย 1 คน',
    MemberGreaterThanBillNotAllow: 'ไม่สามารถใส่จำนวนที่เกินยอดรวมของบิลได้',
    notAllowDot: 'ไม่อณุญาตให้ใส่เครื่องหมาย .',
    slipImage: 'รูปถ่ายใบเสร็จ',

    vatServiceChargeDiscountTitle: 'VAT / Service Charge / ส่วนลด',
    addVatServiceChargeDiscount: '+ เพิ่ม',
    serviceCharge: 'Service Charge',
    vat: 'VAT',
    discount: 'ส่วนลด',
    delelteParentDummy:
      'หากลบสมาชิกนี้ออก จะเป็นการลบคนที่มากับ @{{name}} ไปด้วย ยืนยันการลบหรือไม่',

    placeholderFood: 'เช่น ค่าอาหาร',
    placeholderWater: 'เช่น ค่าน้ำเปล่า',
    placeholderDrink: 'เช่น ค่าเครื่องดื่มอื่นๆ',
    placeholderOther: 'ใส่ชื่อรายการ',
    alreadyHaveOneBillDoYouWantMore:
      'มีบิลสร้างอยู่ในกลุ่ม 1 บิล พี่กำลังจะสร้างบิลเพิ่มหรอครับ?',
    createMoreBill: 'สร้างบิลเพิ่ม',
  },
  randomBillName: {
    morning: {
      morning1: 'ค่าข้าวเช้าจ้าา',
      morning2: 'ขุนทองมาแล้ว',
      morning3: 'คืนเงินด้วยจ้าา',
    },
    afternoon: {
      afternoon1: 'มื้อเที่ยงค้าบบ',
      afternoon2: 'ค่าข้าวกลางวันจ้าา',
      afternoon3: 'ค่าข้าวเที่ยงจ้าา',
    },
    evening: {
      evening1: 'ค่าข้าวเย็นจ้า',
      evening2: 'มื้อเย็นจัดไป',
      evening3: 'มื้อเย็นเบาๆ',
    },
    general: {
      general1: 'คืนเงินด้วยจ้าา',
      general2: 'มาเก็บเงินแล้วว',
      general3: 'อย่าลืมจ่ายน้าา',
      general4: 'ขุนทองมาแล้ว',
      general5: 'เข้ามาจ่ายได้เลย',
    },
  },
  accountManagementPage: {
    mainButton: 'บันทึก',
    manageAccount: 'จัดการบัญชี',
    kPlusAccount: {
      addAccountByKPLUS: 'เชื่อมต่อบัญชีกสิกรไทย',
      kplusRemark: 'เฉพาะลูกค้าที่มี K PLUS',
      paymentAccount: 'บัญชีจ่ายเงิน',
      cancelAccountBinding: 'ยกเลิกการผูกบัญชี',
      accountName: 'Account Name',
      number: 'Number',
    },
    recipientAccount: {
      addAccount: 'เพิ่มบัญชีรับเงิน',
      addAccountRemark: 'ได้ทุกธนาคาร รับเงินสะดวก',
      recipientAccount: 'บัญชีรับเงิน',
      accountName: 'Account Name',
      number: 'Number',
    },
    accountSetting: {
      setting: 'ตั้งค่าการใช้งาน',
      termAndCondition: 'ข้อตกลงและเงื่อนไขการใช้งาน',
      PDPA: 'การจัดการข้อมูลส่วนบุคคล',
    },
  },
  inviteFriendPage: {
    nextBtn: 'คิดเงิน',
    mainBtn: 'ต่อไป',
    title: 'เก็บเงินใครบ้าง~?',
    search: 'ค้นหารายชื่อในห้อง',
    allmember: 'ทุกคนในกลุ่ม',
    addMoreFriend: 'เพิ่มคนนอกกลุ่ม',
    save: 'บันทึก',
  },
  billAssignPage: {
    title: 'รายการของใคร~?',
    selectAllMember: 'เลือกทั้งหมด ({{length}})',
    friendNotSelect:
      'เพื่อนที่ยังไม่ได้เลือก ({{nonSelectLength}}/{{memberLength}})',
    billSummary: 'สรุปบิล',
    save: 'บันทึก',
    warning: {
      alreadySummary: 'ขออภัย! ขุนทองสรุปยอดไปแล้ว<br/>ไปยัง หน้าสรุปบิล',
      alreadyClose: 'ขออภัย! บิลนี้ปิดไปแล้ว<br/>ไปยัง หน้าสรุปบิล',
      pleaseSelectMember: 'กรุณาเลือกสมาชิก',
      friendNotSelect:
        'อุ๊บส์! มีเพื่อนยังไม่ได้เลือกอีก {{remainMember}} คน<br/>ช่วยตามเพื่อนมาเลือกก่อนนะครับ',
      orderNotSelect:
        'อุ๊บส์! มีรายการที่ยังไม่ได้เลือกอีก {{remainItem}} อย่าง<br/>ช่วยตามเพื่อนมาเลือกก่อนนะครับ',
      vatNoMember:
        'อุ๊บส์! มี {{items}} ที่ยังไม่ได้เลือก ช่วยตามเพื่อนมาเลือกก่อนนะครับ',
      cannotBackToEdit: 'ขออภัย! บิลนี้ถูกสร้างไปแล้ว\nเปลี่ยนแปลงไม่ได้จ้าาา~',
      onlyOwnerCanSummarize: 'ให้เจ้าของบิล @{{ownerName}} เป็นคนสรุปบิลนะ',
      willDeleteDummies: 'ถ้าลบ @{{parentName}} จะลบ {{dummiesName}} ไปด้วยนะ',
      willDeleteMember: 'คุณต้องการลบ @{{name}} หรือไม่ ?',
    },
    splitEvenly: 'หารเท่า',
    splitProportionately: 'หารตามสัดส่วน',
    edit: 'แก้ไข',
    dialogEditItems: {
      saveItems: 'บันทึกรายการ',
      edit: 'แก้ไข',
      save: 'บันทึก',
      itemUnnamed:
        'อุ๊บส์! มีรายการที่ยังไม่ได้ใส่ชื่ออีก {{remainItem}} อย่าง<br/>ใส่ชื่อรายการก่อนนะครับ',
      itemNoPrice:
        'อุ๊บส์! มีรายการที่ยังไม่ได้ใส่ราคาอีก {{remainItem}} อย่าง<br/>ใส่ราคาก่อนนะครับ',
    },
    addPerson: 'เพิ่มคน',
    calculateBill: 'คิดเงิน',
  },
  payTypePage: {
    billCancle: 'บิลนี้ถูกยกเลิก ไม่ต้องจ่ายจ้าา~',
    billOwner: 'เจ้าของบิลไม่ต้องจ่ายจ้าา~',
    paySuccess:
      'คุณจ่ายเงินบิล "{{billName}}"<br/>{{amount}} บาท ให้คุณ {{ownerName}} เรียบร้อย {{extendMessage}}',
    waitForConfirm: '<br/>( รอตรวจสอบจากผู้รับเงิน )',
    //transfer: 'โอนให้',
    //accountNo: 'เลขบัญชี:',
    promptpay: 'พร้อมเพย์',
    selectMethod: 'เลือกวิธีการจ่าย',
    paymentOption: {
      kplusLink: 'จ่ายด้วย K PLUS',
      kplus: 'ธ.กสิกรไทย {{accountNo}}',
      kplusAdd: 'ผูกบัญชีขุนทองผ่าน K PLUS',
      slip: 'อัพโหลดรูปสลิป (ที่มี QR Code)',
      cash: 'ฉันจ่ายด้วยเงินสดแล้ว',
    },
    warningKplus: 'Powered by KBANK',
    kplusOtherDevice:
      'กรุณาผูกบัญชีผ่าน K PLUS ใหม่! เนื่องจากมีการเคลียร์ข้อมูลในเครื่อง หรือ ใช้ขุนทองบนเครื่องใหม่',
    warning: {
      receiveAccChanged: {
        content1: 'ตรวจสอบบัญชีก่อนโอนด้วยนะ',
        content2: '@{{lineName}} เพิ่งเปลี่ยนบัญชีรับเงินใหม่',
        button: 'รับทราบ!',
      },
      payWaiting:
        'ถ้าโอนผ่าน K PLUS แล้ว กรุณาส่งสลิปจาก K PLUS เข้ามาในห้องแชทด้วยน้าา~',
      payOverLimit: {
        title:
          '<b>วงเงินโอนต่อวันคือ {{transferLimit}} บาท</b><br/>วงเงินโอนผ่านขุนทองเกินกำหนดต่อวัน น้องแนะนำให้จ่ายด้วยวิธีอื่นนะค้าบ (วงเงินคงเหลือต่อวันคือ {{amount}} บาท)',
        kbank: {
          button: 'โอนเงินผ่าน K PLUS >',
        },
        other: {
          button: 'ตกลง',
        },
      },
    },
    billAmountAdaptedFrom: 'ยอดจ่ายบิล ถูกปรับจาก',
    bindedAccount: 'บัญชีที่ผูกไว้',
    transferTo: 'โอนให้',
    privateBillDetail: '“{{billName}}” จาก @{{ownerName}}',
    pleasVerify: 'โปรดตรวจสอบรายละเอียดบิลก่อน ก่อนกดจ่ายเงิน',
    account: 'บัญชีรับเงิน',
    reject: 'ไม่ใช่บิลของฉัน',
    pay: 'จ่ายเงิน',
    overImageSize: '<b>น้องว่าไฟล์นี้ใหญ่ไป~</b><br/>รบกวนอัพโหลดรูปใหม่นะค้าบ',
    wrongImageType:
      '<b>น้องไม่รองรับไฟล์ประเภทนี้ค้าบ~</b><br/>รบกวนอัพโหลด e-Slip ที่มี QR น้า',
    privateBillExpire:
      'บิลนี้หมดอายุแล้วน้า<br/>หากคุณพี่จะทำรายการ...ติดต่อเจ้าของบิลเลยจ้า',
    privateBillFull:
      'บิลนี้มีผู้รอจ่ายครบแล้ว...<br/>รบกวนติดต่อเจ้าของบิลค้าบ',
    privateBillMemberNotFound:
      'บิลนี้ไม่ใช่ของพี่นะค้าบ<br/>รบกวนติดต่อเจ้าของบิล<br/>เพื่อตรวจสอบค้าบ',
    privateBillCancel: 'บิลนี้ถูกยกเลิกแล้ว<br/>รบกวนพี่ติดต่อเจ้าของบิล',
  },
  payTypeSelectedPage: {
    promptpay: 'พร้อมเพย์',
    //accountNo: 'เลขบัญชี',
    payCash: 'ฉันจ่ายด้วยเงินสดแล้ว จริงๆนะ!!',
    remark:
      'กรุณาตรวจสอบข้อมูลให้ถูกต้อง หากยืนยันแล้วจะไม่สามารถเปลี่ยนแปลงได้',
    count: 'จำนวน',
    fee: 'ค่าธรรมเนียม',
    cashButton: 'ยืนยันการจ่าย',
    remarkSlip: 'โอนเอง แล้วส่ง Slip เข้ากลุ่ม',
    remarkSlip1: '1. คัดลอกเลขบัญชี',
    remarkSlip2: '2. ไปโอนผ่าน Mobile Banking ของธนาคารที่คุณใช้',
    remarkSlip3: '3. ส่ง e-Slip เข้า Line กลุ่มหรืออัพโหลดในหน้านี้ก็ได้นะ',
    remarkSlipPrivateBill: 'โอนเอง แล้วอัพโหลด e-Slip',
    remarkSlipPrivateBill1: '1. คัดลอกเลขบัญชี',
    remarkSlipPrivateBill2: '2. ไปโอนผ่าน Mobile Banking ของธนาคารที่คุณใช้',
    remarkSlipPrivateBill3: '3. กลับมาอัพโหลด e-Slip เพื่อเป็นหลักฐาน',
    baht: 'บาท',
    transferTo: 'โอนให้',
    uploadButton: 'อัพโหลด e-Slip',
  },
  payTypeStore: {
    comingSoon: 'พบกันเร็วๆนี้',
    transferToBankAccountOnly: 'ใช้โอนให้กับเลขบัญชีธนาคารเท่านั้น',
  },
  selectBankPage: {
    title: 'เลือกธนาคาร',
    placeholder: {
      search: 'ค้นหา',
    },
  },
  billInfoPage: {
    //confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    paymentButtonText: 'จ่ายเงินเลย',
    cancelCollectButtonText: 'ยกเลิกการเก็บเงิน',
    bankAccount: 'บัญชีรับเงิน:',
    summaryButtonText: 'สรุปบิล',
    sendGroupButtonText: 'ส่งบิลเข้ากลุ่ม',
    membersAssignTitleName: 'ยังไม่ได้จ่าย',
    membersPaidTitleName: 'จ่ายแล้ว! 🎉',
    membersWaitingTitleName: 'รอตรวจสอบ: คนที่จ่ายด้วยเงินสด 💸',
    completePay: 'จ่ายครบแล้ว',
    memberListPage: {
      cash: 'เงินสด',
      kplus: 'K PLUS',
      khunthong: 'ขุนทอง',
      transfer: 'สลิป',
      owner: 'เจ้าของ',
    },
    memberTotalLessThanZero:
      'สรุปบิลไม่สำเร็จ! เพื่อนบางคนมียอดเรียกเก็บน้อยกว่าหรือเท่ากับ 0',
    billCanceled:
      '<b>บิลนี้ยังเก็บไม่ครบเลย</b><br/>พี่แน่ใจเหรอว่าจะให้น้องขุนลบจริงๆ',
    cannotCancelBill: 'ขออภัย! ไม่สามารถยกเลิกบิลได้',
    promptpay: 'พร้อมเพย์',
    paid: 'จ่ายแล้ว',
    nopaid: 'ปฏิเสธ',
    paymentTrans: {
      cash: 'เงินสด',
      kplus: 'ชำระด้วยบัญชี ธ.​กสิกรไทย (K PLUS)',
      khunthong: 'ชำระด้วยบัญชี ธ.​กสิกรไทย (KhunThong)',
      transfer: 'ยืนยันด้วยสลิป',
      //owner: 'เจ้าของ',
      channel: 'ช่องทาง',
      //amount: 'ยอดเงิน',
      txnNo: 'เลขที่รายการ',
      txnDate: 'วันที่ทำรายการ',
    },
    paymentTransBottom: {
      amount: 'ยอดเงิน',
      baht: 'บาท',
      remark: 'หมายเหตุ',
      paidMoreThanOneBill: 'ยอดเงินในธุรกรรมนี้ จ่ายทั้งหมด {{billNumber}} บิล',
    },
    notOwner: '<b>ขออภัย! บิลนี้ไม่ใช่ของพี่</b><br/>ไม่สามารถยกเลิกบิลได้ครับ',
    paidWithCashButton: 'เช็คว่าจ่ายแล้ว',
    selectAll: 'เลือกทั้งหมด',
    durationPrefix: 'เก็บทุก',
    summaryBill: 'สรุปบิล',
  },
  paymentSuccessPage: {
    //title: 'จ่ายเงินสำเร็จ',
    completePayResponsibility: 'เรื่องจ่ายเงินต้องไว้ใจพี่จริงๆ',
    completeKPlusPayResponsibility:
      'โอนเงินสำเร็จ เรื่องโอนเงินต้องไว้ใจพี่จริงๆ',
    completePay: 'จ่ายเงินสำเร็จ!',
    completeCashPay: 'จ่ายแล้วด้วยเงินสด รอตรวจสอบ',
    completeKPlusPay: 'โอนเงินสำเร็จ',
    youPaid: 'คุณจ่ายให้',
    youPaidTo: 'เรียบร้อยด้วยเงินสด 💸',
    labelAmount: 'จำนวน:',
    labelRefNo: 'เลขที่รายการ:',
    labelFrom: 'จาก',
    labelTo: 'ไปยัง',
    mainBtn: 'กลับสู่ Chat',
    paymentRemark: 'ธุรกรรมดำเนินการโดยธนาคารกสิกรไทย',
    saveSlipBtn: 'แชร์สลิป',
    thb: 'บาท',
    optionButton: 'ดูอีก {{number}} บิลที่พี่ค้างจ่ายอยู่ ',
    optionButtonSeeWhoPaid: 'ดูว่าใครจ่ายแล้วบ้าง',
    errorAlreadyPaid: {
      withCash: 'ด้วยเงินสด 💸',
      isWaiting: '(รอตรวจสอบจากผู้รับเงิน)',
      youPaid: 'คุณจ่าย “{{billName}}”',
      alreadyPaidCashFor: 'คุณจ่ายให้ {{ownerName}} เรียบร้อย',
      alreadyPaidFor: 'ให้คุณ @{{ownerName}} เรียบร้อย',
      paidWithCashTitle: 'จ่ายแล้วด้วยเงินสด',
      paidWithKPLUSTitle: 'จ่ายแล้วด้วย KPLUS',
      paidWithKhunthongTitle: 'จ่ายแล้วด้วยขุนทอง',
      paidWithSlipTitle: 'จ่ายแล้วยืนยันหลักฐานด้วยสลิป',
      seeDetail: 'ดูรายละเอียด',
    },
  },
  multiplePaymentSuccessPage: {
    //selfConfirmation: 'ยืนยันการจ่ายด้วยตัวเอง',
    selectedAndWait: 'เลือกบิลแล้วรอตรวจสอบ',
    paymentSuccess: 'การจ่ายสำเร็จแล้ว',
    waitForConfirmation: 'รอยืนยันจาก @{{billOwnerName}} ว่าได้รับเงินแล้ว',
    overAmount: 'โอนเกินมา',
    underAmount: 'เหลือต้องจ่ายอีก',
    total: 'รวมเงิน',
    accountNotMatchFromUploadSlip: 'โอนมาไม่ตรงกับบัญชีที่เรียกเก็บ',
    waitForConfirmFromUploadSlip: 'รอผู้รับเงินตรวจสอบ',
    waitForConfirmationFromUploadSlip:
      'รอยืนยันจาก @{{billOwnerName}} ว่าได้รับเงินแล้ว',
  },
  verifyKPlusRegisterPage: {
    header: 'บริการโอนทันใจกับขุนทอง',
    content:
      'ผูกบัญชีจาก K PLUS ก่อนใครเพื่อน เมื่อเป็นพนักงาน KBTG หรือเมื่อลงทะเบียนเป็น Beta User',
    linkRegisterBetaUser: 'ฉันต้องการสมัคร Beta User',
    remark1:
      'หมายเหตุ: วงเงินการจ่ายโดยไม่ใช้ PIN ไม่เกิน {{transferLimit}} บาทต่อวัน  และสามารถนำบัญชีมาใช้เป็นขารับเงินกับขุนทอง ลูกค้าสามารถยกเลิกใช้บริการได้จากห้องแชท Official Account @KhunThong',
    remark2: 'กรุณารอ email ยืนยันจากเรา',
    btnNext: 'เชื่อมต่อบัญชีกสิกรไทย',
    fastTransfer: 'โอนไว',
    within2ClickWithoutSwapping: 'ภายใน 2 คลิก โดยไม่ต้องสลับแอป',
    secure: 'ปลอดภัย',
    withKplusVerification: 'ด้วยการยืนยันตัวตน ผ่าน K PLUS',
    getAChance: 'ลุ้นรับ',
    getPromotionAnd: 'โปรโมชั่นและ',
    manyMorePrivilege: 'สิทธิพิเศษอีกมากมาย',
    getCashback: 'รับเงินรางวัล',
    toGetMoneyFromTheActivity: 'จากกิจกรรม #ชวนเพื่อน',
    moreConvenient: 'สะดวกกว่า',
    toUseKhunThongWithoutPin:
      'เพื่อใช้บริการขุนทองรับเงิน และโอนเงินผ่านขุนทองโดยไม่ต้องใช้ PIN',
    forUserNoKPUS: 'สำหรับลูกค้าที่ไม่มี K PLUS >',
  },
  verifyKPlusPage: {
    phoneLabel: 'หมายเลขโทรศัพท์ K PLUS',
    phonePlaceholder: 'กรอกหมายเลขโทรศัพท์',
    idCardLabel: 'เลขที่บัตรประชาชน',
    idCardPlaceholder: 'กรอกเลขบัตรประชาชน',
    remark:
      'หมายเหตุ: กรุณาตรวจสอบข้อมูลให้ถูกต้อง เนื่องจากสามารถสมัครบริการได้วันละไม่เกิน 3 ครั้งเท่านั้น',
    btnText: 'ดำเนินการต่อด้วย K PLUS',
    submitButton: 'ยืนยัน',
  },
  successPage: {
    //closeButtonText: 'ปิดแท็บนี้',
    successText: 'แชร์สำเร็จแล้วครับ',
    pleaseCloseText: 'กรุณาปิดแท็บนี้ เพื่อใช้ขุนทองต่อ',
  },
  homePage: {
    titleText: 'ขุนทอง',
  },
  termAndCondition: {
    title: 'ข้อกำหนดและเงื่อนไขการใช้บริการ “ขุนทอง”',
    contentHtml:
      '<p><span><strong>ข้อกำหนดและเงื่อนไขการใช้บริการขุนทอง (KhunThong) </strong></span></p><p><span>ผู้</span><span>ใช้บริการตกลงใช้บริการขุนทอง (KhunThong) หรือชื่ออื่นที่บมจ.ธนาคารกสิกรไทย ("</span><span><strong>ธนาคาร</strong></span><span>") พิจารณาเปลี่ยนแปลงตามที่ธนาคารเห็นสมควร ("</span><span><strong>บริการขุนทอง</strong></span><span>") กับ ธนาคาร ตามที่ได้รับอนุมัติจากธนาคาร และตามรายละเอียดที่ธนาคารกำหนด โดยตกลงผูกพันและปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการ ("</span><span><strong>เงื่อนไขการใช้บริการ</strong></span><span>") ดังต่อไปนี้</span></p><p><span>1. ในการใช้บริการขุนทอง ผู้ใช้บริการจะต้องสมัครเป็นผู้ใช้บริการ LINE Messenger ของบริษัท</span><span>  ไลน์ คอร์ปอเรชั่น จำกัด </span><span> (“</span><span><strong>LINE Messenger</strong></span><span>”) และเพิ่ม “</span><span><strong>ขุนทอง</strong></span><span>” เป็นเพื่อนในกลุ่ม LINE Messenger ที่ประสงค์จะใช้บริการ โดยสามารถทำรายการต่างๆ เช่น คำนวณค่าสินค้า/บริการที่ต้องชำระต่อคน สแกนใบเสร็จค่าสินค้า/บริการและคำนวณราคาต้องชำระต่อคน เป็นต้น ทั้งนี้ ตามที่ธนาคารเปิดให้บริการ และภายใต้ข้อกำหนด เงื่อนไข ระยะเวลา ช่องทาง และแบบวิธีการของแต่ละรายการ ผลิตภัณฑ์ และบริการต่างๆ ที่ธนาคารกำหนด โดยผู้ใช้บริการจะต้องใช้ข้อความที่สุภาพ และมีความชัดเจนเพียงพอในการใช้บริการของธนาคาร</span></p><p><span>2. การใช้รหัสประจำตัว และ/หรือรหัสผ่าน และ/หรือรหัส One Time Password (OTP) และ/หรือเครื่องมืออื่นใดที่ผู้ใช้บริการใช้เป็นเครื่องมือในการ Log in เข้าใช้บริการ LINE Messenger (“</span><span><strong>รหัสประจำตัว</strong></span><span>”) เพื่อใช้บริการตามเงื่อนไขการใช้บริการฉบับนี้</span></p><p><span>2. 1. หากการใช้บริการตามเงื่อนไขการใช้บริการฉบับนี้ ธนาคารได้กำหนดให้จะต้องใช้บริการผ่านรหัสประจำตัวแล้ว ผู้ใช้บริการจะต้องระบุรหัสประจำตัวตามเงื่อนไขและขั้นตอนที่ธนาคารกำหนดสำหรับการใช้บริการผ่านช่องทางนั้นๆ</span></p><p><span>2. 2. ผู้ใช้บริการจะต้องเก็บรักษารหัสประจำตัวไว้ในที่ปลอดภัยและถือเป็นความลับเฉพาะตัวของผู้ใช้บริการเท่านั้น การเปิดเผย/มอบรหัสประจำตัวให้บุคคลอื่นถือเป็นการปฏิบัติผิดเงื่อนไขการใช้บริการฉบับนี้ หากเกิดความเสียหายประการใด (ซึ่งรวมถึงเกิดรายการโอนเงิน) จากการที่ผู้ใช้บริการเปิดเผยหรือกระทำการใดๆ จนทำให้บุคคลอื่นล่วงรู้ หรือได้รับรหัสประจำตัว หรือรหัสประจำตัวสูญหายหรือถูกโจรกรรม ผู้ใช้บริการจะต้องรับผิดชอบในความเสียหายดังกล่าวที่เกิดขึ้นก่อนที่ผู้ใช้บริการจะดำเนินการอายัด หรือระงับการใช้รหัสประจำตัวนั้น</span></p><p><span>2. 3. การกระทำใดๆ ซึ่งรวมถึง (แต่ไม่จำกัดเฉพาะ) การสมัครและใช้บริการต่างๆ การชำระค่าสินค้า/บริการ การโอนเงิน การตรวจสอบ/พิสูจน์ตัวตน การอนุมัติการทำธุรกรรมต่างๆ การให้ข้อมูลใดๆ ให้แก่ธนาคาร การตกลงยอมรับ/แก้ไข/เปลี่ยนแปลง/เพิ่มเติม เกี่ยวกับเงื่อนไขการใช้บริการฉบับนี้ ข้อกำหนดและเงื่อนไข/บริการ/อัตราค่าธรรมเนียม ของการใช้บริการต่างๆ ทั้งของธนาคารและ/หรือของบุคคล/นิติบุคคลใดๆ ไม่ว่าจะเป็นการกระทำของผู้ใช้บริการเอง หรือเป็นการกระทำของบุคคลอื่นใด </span><span><strong>หากได้กระทำไปโดยการใช้รหัสประจำตัวแล้ว ผู้ใช้บริการตกลงให้ถือว่าถูกต้องสมบูรณ์ และให้มีผลผูกพันผู้ใช้บริการเสมือนหนึ่งได้กระทำโดยผู้ใช้บริการเอง รวมทั้งให้ถือว่าเป็นการที่ผู้ใช้บริการได้ลงลายมือชื่ออิเล็กทรอนิกส์ให้ไว้แก่ธนาคาร</strong></span><span>เพื่อเป็นหลักฐานในการทำธุรกรรมในครั้งนั้นๆ โดยถูกต้องสมบูรณ์แล้ว นับตั้งแต่เวลาที่มีการยืนยันทำธุรกรรม ทั้งนี้ ผู้ใช้บริการตกลงยอมรับและรับทราบถึงความเสี่ยงที่เกี่ยวเนื่องกับการใช้บริการผ่านช่องทางอิเล็กทรอนิกส์ เนื่องจากผู้ใช้บริการสามารถทำธุรกรรมได้โดยไม่จำเป็นต้องมีเอกสาร หรือหลักฐานอื่นใดยืนยันเพิ่มเติม และ/หรือมอบให้แก่ธนาคารอีก เว้นแต่ธนาคารกำหนดเป็นอย่างอื่น และผู้ใช้บริการต้องตรวจสอบยอดเงินภายหลังจากทำรายการทุกครั้ง</span></p><p><span>3. ผู้ใช้บริการที่เป็นผู้ขอรับชำระค่าสินค้า/บริการ (“</span><span><strong>ผู้ส่งคำขอเรียกเก็บเงิน</strong></span><span>”) สามารถขอให้ธนาคารเรียกให้บุคคลอื่น (“</span><span><strong>ผู้รับคำขอเรียกเก็บเงิน</strong></span><span>”) โอน/ชำระเงินให้แก่ตนเอง ตามข้อมูลและรายละเอียดจำนวนเงิน รายการสินค้า/บริการ และรายชื่อที่ผู้ส่งคำขอเรียกเก็บเงินระบุ ทั้งนี้ ผู้ใช้บริการรับทราบและตกลงว่าบริการตามเงื่อนไขการใช้บริการฉบับนี้เป็นเพียงช่องทางที่ระบบของธนาคารให้บริการคำนวณค่าสินค้า/บริการเบื้องต้น และแสดงรายละเอียดผลการคำนวณค่าสินค้า/บริการเท่านั้น โดยผลของการคำนวณค่าสินค้า/บริการขึ้นอยู่กับความถูกต้องครบถ้วนของข้อมูลและรายละเอียดที่ผู้ส่งคำขอเรียกเก็บเงินกรอกในบริการ และระบบของธนาคารจะคำนวณค่าสินค้า/บริการแบบปัดเศษขึ้น ตามวิธีการที่ธนาคารกำหนด ซึ่งอาจจะไม่ถูกต้องตรงตามจำนวนเงินรวมจริง ดังนั้น ผู้ใช้บริการจะต้องตรวจสอบจำนวนเงินที่ถูกคำนวณอีกครั้ง</span></p><p><span>4. ผู้รับคำขอเรียกเก็บเงินสามารถโอน/ชำระเงินให้แก่ผู้ส่งคำขอเรียกเก็บเงิน </span><span>(1) ด้วยตนเองโดยตรง และ/หรือ </span><span>(2) ผ่านตู้ ATM และ/หรือ </span><span>(3) ผ่านบริการของธนาคารหรือผู้ให้บริการต่างๆ ตามข้อกำหนดและเงื่อนไขที่ธนาคารหรือผู้ให้บริการนั้นๆ กำหนด และ/หรือ </span><span>(4) ด้วยการหักเงินจากบัญชีเงินฝากของผู้รับคำขอเรียกเก็บเงินที่ผูกไว้ โดยผู้รับคำขอเรียกเก็บเงินจะต้อง Log in เข้าสู่บริการ K PLUS เพื่อทำการผูกบัญชีเงินฝากชื่อผู้รับคำขอเรียกเก็บเงินคนเดียวเข้ากับบริการขุนทอง ด้วยเครื่องมือโอนเงินตามที่ระบุในข้อกำหนดและเงื่อนไขการใช้บริการ K PLUS และในการโอน/ชำระเงินแต่ละครั้ง ผู้รับคำขอเรียกเก็บเงินสามารถทำรายการโดยไม่ต้อง Log in เข้าสู่บริการ K PLUS ภายในวงเงินไม่เกิน 1,000 บาท/วัน หรือตามที่ธนาคารกำหนด ทั้งนี้ หากธนาคารได้รับคำสั่งยืนยันรายละเอียดการโอน/ชำระเงินจากการกดเลือกวิธีการจ่ายด้วยบัญชีเงินฝากที่ผูกไว้ ไม่ว่าจะเป็นการกระทำของบุคคลใดก็ตาม ผู้รับคำขอเรียกเก็บเงินตกลงยินยอมให้ธนาคารหักเงินจากบัญชีเงินฝากที่ผูกไว้ดังกล่าว ตามจำนวนเงินที่ระบุไว้ และโอน/ชำระเงินให้แก่ผู้ส่งคำขอเรียกเก็บเงินได้ทันที </span><span>(5) ด้วยการหักเงินจากบัญชีเงินฝากของผู้รับคำขอเรียกเก็บเงินผ่านบริการ K PLUS ภายในวงเงินทำรายการต่อวันที่ผู้ใช้บริการตั้งสำหรับบริการ K PLUS ตามขั้นตอนหรือวิธีการที่ธนาคารกำหนด</span></p><p><span>5. ทุกครั้งที่มีการโอน/ชำระเงิน ผู้ใช้บริการจะต้องตรวจสอบความครบถ้วนและถูกต้องของข้อมูลการชำระโอน/ชำระเงิน ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะ ชื่อ-นามสกุลของผู้ส่งคำขอเรียกเก็บเงิน ชื่อธนาคาร ชื่อบัญชีเงินฝาก เลขที่บัญชี</span><span>เงินฝาก จำนวนเงิน (หากมี)</span></p><p><span>6. ผู้ใช้บริการตกลงยินยอมให้ธนาคารหักเงินจากบัญชีเงินฝากของผู้ใช้บริการ เพื่อให้ธนาคารทำรายการ และ/หรือดำเนินการตามวิธีการแห่งเงื่อนไขการใช้บริการฉบับนี้ โดยไม่จำต้องบอกกล่าว ทั้งนี้ธนาคารจะนำส่งหลักฐานการหักบัญชีให้ผู้ใช้บริการทราบ</span></p><p><span>7. ผู้ใช้บริการยินยอมให้ธนาคารมีสิทธิหักเงินบัญชีเงินฝากของผู้ใช้บริการ และ/หรือบัญชีเงินฝากประเภทใดๆ ที่ผู้ใช้บริการมีอยู่กับธนาคาร หรือเงินซึ่งอยู่ในความครอบครองดูแล และ/หรือในอำนาจสั่งการของธนาคารไม่ว่าธนาคารจะได้รับฝากเงิน ได้การครอบครองดูแล และ/หรือได้อำนาจสั่งการนี้มาโดยทางใด เพื่อเข้าชำระหนี้ และ/หรือความรับผิดชอบของผู้ใช้บริการได้ทันทีโดยไม่จำต้องบอกกล่าว ทั้งนี้ธนาคารจะนำส่งหลักฐานการหักบัญชีให้ผู้ใช้บริการทรา</span><span>บ</span><span>ในกรณีที่เงินในบัญชีเงินฝาก และ/หรือเงินดังกล่าว ไม่เพียงพอให้หักชำระหนี้ และ/หรือความรับผิดชอบของผู้ใช้บริการ ผู้ใช้บริการตกลงชำระหนี้ที่ค้างชำระให้แก่ธนาคารจนครบถ้วน</span></p><p><span>8. การให้บริการของธนาคารมิได้เป็นการรับประกันว่าผู้ส่งคำขอเรียกเก็บเงินจะได้รับโอน/ชำระเงินจากผู้รับคำขอเรียกเก็บเงิน ทั้งนี้ ขึ้นอยู่กับผู้รับคำขอเรียกเก็บเงินจะได้รับคำขอเรียกเก็บเงินหรือไม่ และจะโอน/ชำระเงินให้แก่ผู้ใช้บริการหรือไม่ เมื่อใดก็ได้ และโอน/ชำระเงินด้วยวิธีการใดก็ได้ โดยธนาคารไม่มีส่วนเกี่ยวข้องกับข้อมูลและรายละเอียดที่ผู้ใช้บริการกรอกแต่อย่างใด ดังนั้น ผู้ใช้บริการตกลงยอมรับว่า ธนาคารไม่ต้องรับผิดชอบในความเสียหายใดๆ หาก (1) ข้อมูลที่ผู้ส่งคำขอเรียกเก็บเงินกรอกไม่ถูกต้องครบถ้วน หรือ (2) ผู้ใช้บริการมิได้เปิดใช้ LINE Messenger อยู่ในขณะนั้น หรือ (3) ผู้รับคำขอเรียกเก็บเงิน ไม่โอน/ชำระเงินให้แก่ผู้ส่งคำขอเรียกเก็บเงิน ไม่ว่าทั้งหมดหรือแต่บางส่วน และไม่ว่าเมื่อใด หรือ (4) LINE Messenger หรือระบบอินเทอร์เน็ตของผู้ใช้บริการที่ไม่ได้อยู่ในการควบคุมของธนาคาร ขัดข้อง หรือมีภัยธรรมชาติ หรือการจลาจล หรือมีเหตุสุดวิสัยใดๆ เกิดขึ้น ทำให้ระบบการส่ง-รับข้อมูลและรายละเอียดไม่สามารถดำเนินการได้ </span></p><p><span>9. ผู้ใช้บริการตกลงว่าผู้ใช้บริการจะต้องอยู่ภายใต้กฎหมาย ข้อบังคับ คำสั่ง และหลักเกณฑ์ใดๆ ของธนาคาร และหน่วยงานผู้มีอำนาจควบคุมหรือกำกับดูแลธนาคาร ศาล และหน่วยงานอื่นใดที่มีอำนาจ (แล้วแต่กรณี) ทั้งที่มีอยู่แล้วขณะนี้และ/หรือจะมีขึ้นในภายหน้า (ซึ่งต่อไปนี้ หากไม่กล่าวโดยเฉพาะเจาะจง จะรวมเรียกว่า “</span><span><strong>กฎหมายและกฎเกณฑ์ที่เกี่ยวข้อง</strong></span><span>”) หากมีการเปลี่ยนแปลงกฎหมายและกฎเกณฑ์ที่เกี่ยวข้อง ผู้ใช้บริการตกลงว่า ผู้ใช้บริการจะต้องปฏิบัติตามกฎหมายและกฎเกณฑ์ที่เกี่ยวข้องที่เปลี่ยนแปลงนั้นทันทีตามที่ธนาคารจะแจ้งให้ผู้ใช้บริการทราบ หากผู้ใช้บริการฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายและกฎเกณฑ์ที่เกี่ยวข้อง จนเป็นเหตุให้ธนาคารถูกเรียกค่าปรับ ค่าเสียหาย และ/หรือค่าใช้จ่ายอื่นๆ (หากมี) ผู้ใช้บริการตกลงรับผิดชอบชดใช้ค่าปรับ ค่าเสียหาย และ/หรือค่าใช้จ่ายดังกล่าว ให้แก่ธนาคารโดยพลัน</span></p><p><span>10. ข้อมูลด้านการเงิน การบัญชี หรือข้อมูลใดๆ ที่ธนาคารและผู้ใช้บริการได้จัดส่งให้แก่กันภายใต้บริการตามเงื่อนไขการใช้บริการฉบับนี้ ถือเป็นข้อมูลลับที่ผู้ใช้บริการไม่พึงเปิดเผยต่อบุคคลภายนอก</span></p><p><span>11. ผู้ใช้บริการตกลงยินยอมให้ธนาคารเก็บรวบรวมและใช้ข้อมูลของผู้ใช้บริการที่ให้ไว้แก่ธนาคาร หรือให้ผ่านธนาคาร หรือมีอยู่กับธนาคาร หรือที่ธนาคารได้รับหรือเข้าถึงได้จากแหล่งอื่น โดยมีวัตถุประสงค์ที่จำเป็นเพื่อการให้บริการแก่ผู้ใช้บริการ การดำเนินการตามคำขอของผู้ใช้บริการก่อนให้บริการ การมอบหมายงานให้ผู้อื่นสนับสนุนการให้บริการไม่ว่าจะเกี่ยวกับงานเทคโนโลยีสารสนเทศ งานติดต่อสื่อสาร งานติดตามทวงถาม หรืองานอื่นใดก็ตาม การโอนสิทธิและ/หรือหน้าที่ การปฏิบัติตามกฎหมาย การบริหารความเสี่ยง การควบคุมกำกับตรวจสอบ การบริหารจัดการภายในองค์กร การจัดการข้อร้องเรียน และ/หรือ เพื่อวัตถุประสงค์อื่นใดที่จำเป็นต่อการดำเนินการของธนาคารอย่างมีนัยสำคัญ หรือเพื่อให้ธนาคารสามารถให้บริการได้อย่างเป็นธรรมและต่อเนื่อง และผู้ใช้บริการตกลงยินยอมให้ธนาคารเปิดเผยข้อมูลดังกล่าวให้แก่กลุ่มธุรกิจทางการเงินธนาคารกสิกรไทย ผู้ให้บริการภายนอก ตัวแทนของธนาคาร ผู้รับจ้างช่วงงานต่อ พันธมิตรทางธุรกิจที่ออกผลิตภัณฑ์ร่วมกัน (co-brand) ผู้ประมวลผลข้อมูล ผู้สอบบัญชี ผู้ตรวจสอบภายนอก บริษัทข้อมูลเครดิต บริษัทจัดอันดับความน่าเชื่อถือ บริษัทบริหารสินทรัพย์ ผู้สนใจจะเข้ารับโอนสิทธิ ผู้รับโอนสิทธิ ผู้มีอำนาจตามกฎหมาย และ/หรือหน่วยงาน/องค์กร/นิติบุคคลใดๆ ที่มีสัญญาอยู่กับธนาคาร และยินยอมให้ผู้รับข้อมูลจากธนาคารดังกล่าว เก็บรวบรวม ใช้ และเปิดเผยข้อมูลดังกล่าวต่อไปได้ภายใต้วัตถุประสงค์ดังกล่าว และตกลงยินยอมให้ส่ง และ/หรือ โอนข้อมูลไปเก็บไว้บน server/cloud ในประเทศต่างๆ ที่เกี่ยวข้อง</span><span> </span><span>รายละเอียดอื่นๆ และสิทธิ ปรากฏในนโยบายการคุ้มครองข้อมูลส่วนบุคคลในเว็บไซต์ของธนาคาร </span><span>www.kasikornbank.com/th/privacy-policy</span></p><p><span>12. ในกรณีที่ความผิดพลาดในการชำระเงิน/โอนเงินไม่ได้เกิดขึ้นจากธนาคาร ผู้ใช้บริการจะตรวจสอบ และเรียกร้องเงินกับคู่พิพาทของผู้ใช้บริการ หรือคืนเงินให้แก่คู่พิพาทของผู้ใช้บริการโดยตรง และหากผู้ใช้บริการมีข้อต่อสู้และ/หรือสิทธิเรียกร้องใดๆ ก็จะไปว่ากล่าวกันเองกับคู่พิพาทของผู้ใช้บริการ</span></p><p><span>13. เว้นแต่ธนาคารจะกำหนดไว้เป็นอย่างอื่น ในกรณีที่ผู้ใช้บริการพบข้อผิดพลาดใดๆ หรือในกรณีที่มีเหตุที่ต้องระงับการดำเนินการภายใต้บริการขุนทองนี้ เป็นการชั่วคราว ไม่ว่าทั้งหมดหรือบางส่วน หรือในกรณีการยกเลิกการระงับการดำเนินการดังกล่าว ผู้ใช้บริการสามารถติดต่อที่ K-Contact Center โทร. 02-8888888 ตลอด 24 ชั่วโมง หรือช่องทางอื่นที่ธนาคารกำหนด พร้อมทั้งแจ้งข้อมูลที่เกี่ยวข้อง เช่น เรื่อง วัน เวลา ผู้ที่เกี่ยวข้อง จำนวนเงิน ลักษณะธุรกรรม ข้อมูลอื่นใดตามที่ธนาคารร้องขอ เมื่อผู้ใช้บริการดำเนินการต่างๆ ตามกระบวนการที่ธนาคารกำหนดครบถ้วนสมบูรณ์แล้ว ธนาคารจะดำเนินการที่เกี่ยวข้อง เช่น ตรวจสอบ/แก้ไขข้อผิดพลาด ระงับการดำเนินการ หรือยกเลิกระงับการดำเนินการให้แล้วเสร็จตามระยะเวลาที่ธนาคารได้แจ้งแก่ผู้ใช้บริการทราบ โดยผู้ใช้บริการยังคงเป็นผู้รับผิดชอบในการดำเนินการ รวมถึงรายการธุรกรรมที่ได้เกิดขึ้นก่อนครบกำหนดระยะเวลาดังกล่าว ทั้งนี้ ธนาคารขอสงวนสิทธิในการเพิกเฉยต่อคำร้องขอใดๆที่ขัดต่อกฎหมายและกฎเกณฑ์</span><span>ที่</span><span>เกี่ยวข้อง </span></p><p><span>14. หากผู้ใช้บริการไม่ได้ใช้งาน/มีการเปลี่ยน/ยกเลิก/ไม่ได้ครอบครอง บัญชีการใช้งาน LINE Messenger (LINE Account) ที่ผูกอยู่กับบริการขุนทอง ผู้ใช้บริการมีหน้าที่แจ้งให้ธนาคารทราบเพื่อระงับการใช้บริการทันทีตามกระบวนการของธนาคาร โดยธนาคารไม่มีหน้าที่ต้องตรวจสอบข้อมูลดังกล่าวหรือรับผิดชอบในความเสียหายที่เกิดขึ้นก่อนที่ธนาคารจะระงับการใช้บริการเสร็จสิ้น ทั้งนี้ หากผู้ใช้บริการไม่แจ้งให้ธนาคารทราบและมีความเสียหายใดๆ เกิดขึ้น ไม่ว่ากับธนาคารหรือบุคคลใดก็ตาม ผู้ใช้บริการตกลงรับผิดชอบในความเสียหายดังกล่าวทั้งสิ้นทุกประการ</span></p><p><span>15. ค่าธรรมเนียม/ค่าบริการ/ค่าใช้จ่าย/ค่าปรับ/ภาษีอากร</span></p><p><span>15. 1. ผู้ใช้บริการตกลงชำระค่าตอบแทนการใช้บริการไม่ว่าจะเรียกว่าค่าธรรมเนียม ค่าบริการ หรือชื่ออื่นใด ให้แก่ธนาคาร ภายในกำหนดเวลาชำระของค่าตอบแทนนั้นๆ หากผู้ใช้บริการไม่ชำระค่าตอบแทนดังกล่าวภายในกำหนดเวลาชำระ ผู้ใช้บริการตกลงชำระค่าตอบแทนดังกล่าวให้แก่ธนาคาร</span></p><p><span>15. 2. ผู้ใช้บริการตกลงรับผิดชอบค่าฤชาธรรมเนียม ภาษีอากร และค่าใช้จ่ายใดๆ ที่เกี่ยวข้องกับบริการ (หากมี) แต่เพียงฝ่ายเดียว</span><span> </span><span>หากธนาคารจำต้องทดรองจ่ายค่าฤชาธรรมเนียม ภาษีอากร และ/หรือค่าใช้จ่ายดังกล่าวตามวรรคก่อนแทนผู้ใช้บริการไปก่อน ผู้ใช้บริการตกลงชำระคืนให้แก่ธนาคารโดยพลัน</span></p><p><span>16. ผู้ใช้บริการรับรองว่า บรรดาเอกสาร ข้อมูล รายละเอียดใด ๆ ที่ปรากฏ และ/หรือที่ได้มีการจัดส่งมาให้ธนาคาร ไม่ว่าจะส่งมาในรูปแบบหรือช่องทางใดก็ตาม และไม่ว่าจะส่งด้วยตัวผู้ใช้บริการเอง หรือผ่านบุคคลใดๆ ก็ตามผ่านรหัสประจำตัว มีความครบถ้วน ถูกต้องแท้จริง และเป็นปัจจุบัน และเป็นข้อมูลที่ธนาคารสามารถนำมาใช้ในการให้บริการและนำมาปรับปรุงข้อมูลในระบบของธนาคารให้เป็นปัจจุบันได้ โดยผู้ใช้บริการมีสิทธิและมีความสามารถตามกฎหมายในการขอใช้บริการและการทำธุรกรรมใดๆ ที่เกี่ยวข้องกับการใช้บริการขุนทอง</span></p><p><span>17. หากผู้ใช้บริการมีความประสงค์จะสอบถามหรือ ขอแก้ไขข้อมูล และ/หรือรายละเอียดต่างๆ ผู้ใช้บริการสามารถติดต่อ K-Contact Center โทรศัพท์หมายเลข 02-8888888</span></p><p><span>18. การเปลี่ยนแปลงเงื่อนไขการใช้บริการ</span></p><p><span>18. 1. หากเป็นการเปลี่ยนแปลงเงื่อนไขที่ส่งผลให้ผู้ใช้บริการเกิดภาระหรือความเสี่ยงที่เพิ่มขึ้น การเปลี่ยนแปลงดังกล่าวจะมีผลเมื่อผู้ใช้บริการให้ความยินยอม</span></p><p><span>18. 2. หากเป็นการเปลี่ยนแปลงเงื่อนไขอื่น ผู้ใช้บริการตกลงยินยอมให้ธนาคารมีสิทธิเปลี่ยนแปลงได้ตามที่ธนาคารเห็นสมควร โดยหากเป็นการเปลี่ยนแปลงที่มีผลกระทบต่อการใช้บริการของผู้ใช้บริการ (เช่น การปรับค่าธรรมเนียมการใช้บริการที่สอดคล้องกับต้นทุนที่เพิ่มขึ้น การเปลี่ยนแปลงช่องทางในการให้บริการ การเปลี่ยนแปลงวันครบกำหนดชำระหนี้) ธนาคารจะสื่อสารหรือแจ้งข้อมูลอันเป็นสาระสำคัญของการเปลี่ยนแปลงที่ชัดเจนให้ผู้ใช้บริการทราบล่วงหน้าไม่น้อยกว่า 30 (สามสิบ) วัน หรือระยะเวลาอื่นตามที่กฎหมายกำหนด</span></p><p><span>18. 3. หากมีกฎหมายและ/หรือกฎเกณฑ์กำหนดให้ธนาคารต้องดำเนินการเกี่ยวกับการเปลี่ยนแปลงเงื่อนไขไว้เป็นการเฉพาะเป็นอย่างอื่น ผู้ใช้บริการตกลงยินยอมให้ธนาคารปฏิบัติตามกฎหมายและ/หรือกฎเกณฑ์ดังกล่าวได้</span></p><p><span>19. ธนาคารมีสิทธิที่จะระงับ และ/หรือยกเลิกบริการต่างๆ ได้ไม่ว่าทั้งหมดหรือบางส่วน หรือเฉพาะแต่ผู้ใช้บริการรายใดรายหนึ่งเมื่อใดก็ได้ โดยธนาคารจะแจ้งให้ทราบล่วงหน้า เว้นแต่ในกรณีดังต่อไปนี้ ผู้ใช้บริการตกลงว่าธนาคารมีสิทธิระงับ และ/หรือยกเลิกการให้บริการ ไม่ว่าทั้งหมดหรือบางส่วนได้</span><span><strong>ทันที</strong></span><span> ตามที่ธนาคารเห็นสมควร โดยไม่จำต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า และธนาคารไม่ต้องรับผิดชอบในความเสียหายใดๆ ที่เกิดจากการดำเนินการดังกล่าว</span></p><p><span>19. 1. ข้อมูล รายละเอียด คำรับรองหรือคำยืนยันใดๆ ที่ผู้ใช้บริการให้ไว้แก่ธนาคาร ไม่เป็นความจริง ไม่ถูกต้อง หรืออาจก่อให้เกิดความเข้าใจผิดในสาระสำคัญ </span></p><p><span>19. 2. ปรากฏข้อเท็จจริงที่ธนาคารเชื่อได้ว่า ข้อมูล และ/หรือรายละเอียดต่างๆ ที่ผู้ใช้บริการแจ้งแก่ธนาคารให้ดำเนินการ หรือการใช้บริการขุนทองของผู้ใช้บริการอาจก่อให้เกิดผลกระทบในทางที่ไม่เป็นคุณเกิดขึ้น หรืออาจกระทบต่อสิทธิของธนาคารหรือบุคคลอื่น หรือมีความเสี่ยงว่าผู้ใช้บริการอาจมีวัตถุประสงค์อันมิชอบด้วยกฎหมาย หรืออาจขัดต่อความสงบเรียบร้อยหรือศีลธรรมอันดีของประชาชน หรือใช้ข้อความที่ไม่สุภาพ หรือธนาคารเห็นว่าเป็นการกระทำโดยหรือมีแนวโน้มที่จะกระทำโดยมิจฉาชีพ หรือเป็นการกระทำที่มีลักษณะที่ผิดปกติ หรืออาจทำให้ธนาคารปฏิบัติผิดกฎหมาย และ/หรือกฎข้อบังคับ และ/หรือคำสั่งใดๆ และ/หรือคำขอความร่วมมือใด ๆ และกฎหรือคำสั่งใด ๆ ของธนาคาร และ/หรือธนาคารแห่งประเทศไทย และ/หรือผู้ตรวจสอบ และ/หรือหน่วยงานผู้มีอำนาจควบคุมหรือกำกับดูแลธนาคาร หรืออาจส่งผลกระทบต่อภาพลักษณ์ของธนาคาร</span></p><p><span>19. 3. ผู้ใช้บริการปฏิบัติผิดเงื่อนไขการใช้บริการฉบับนี้ไม่ว่าข้อหนึ่งข้อใด ซึ่งรวมถึงการไม่ชำระค่าธรรมเนียม/ค่าบริการ/ค่าใช้จ่าย/ค่าปรับ/ภาษีอากร (หากมี) ที่เกิดขึ้นด้วย</span></p><p><span>19. 4. มีเหตุการณ์ใดเกิดขึ้นหรืออาจจะเกิดขึ้นอันทำให้ธนาคารเห็นว่าจะมีผลกระทบต่อการดำเนินกิจการหรือความสามารถในการชำระหนี้ของผู้ใช้บริการ หรือผู้ใช้บริการเสียชีวิต หรือผู้ใช้บริการเลิกกิจการ ถูกเพิกถอนทะเบียน หรือถูกระงับไม่ให้ดำเนินธุรกิจ หรือมีการชำระบัญชี</span></p><p><span>19. 5. ธนาคารไม่สามารถหักเงินเพื่อดำเนินการตามเงื่อนไขการใช้บริการฉบับนี้ </span></p><p><span>19. 6. หากธนาคารตรวจพบว่า มีความเสี่ยงที่จะเกิดความเสียหายอันเนื่องมาจากอุปกรณ์ของผู้ใช้บริการถูกดัดแปลงแก้ไข หรือเนื่องมาจากระบบเครือข่ายโทรศัพท์เคลื่อนที่ และ/หรือเหตุอื่นใด เช่น การ Jailbreak (“</span><span><strong>Jailbreak</strong></span><span>” หมายถึง การแก้ไขระบบหรือส่วนของระบบปฏิบัติการ iOS ของอุปกรณ์ ที่ทำให้มีการเปลี่ยนแปลงสิทธิในการใช้งานของผู้ใช้โดยไม่ได้รับอนุญาตจากผู้ผลิต/เจ้าของระบบปฏิบัติการ) หรือ Root (“</span><span><strong>Root</strong></span><span>” หมายถึง การแก้ไขระบบหรือส่วนของระบบปฏิบัติการ Android ของอุปกรณ์ ที่ทำให้มีการเปลี่ยนแปลงสิทธิในการใช้งานของผู้ใช้โดยไม่ได้รับอนุญาตจากผู้ผลิต/เจ้าของระบบปฏิบัติการ) เป็นต้น ทั้งนี้ เพื่อป้องกันความเสียหายที่จะเกิดขึ้นกับผู้ใช้บริการ</span></p><p><span>19. 7. ธนาคารต้องปฏิบัติตามนโยบาย กฎ ระเบียบ ข้อบังคับ คำสั่ง กฎหมาย คำสั่งและ/หรือการขอความร่วมมือของศาล หรือของหน่วยงานที่มีอำนาจตามกฎหมาย หรือหน่วยงานที่มีอำนาจกำกับดูแลธนาคาร</span></p><p><span>19. 8. ธนาคารทราบอย่างชัดเจน หรือมีข้อสงสัยว่ามีกรณีดังกล่าวในข้อ 14. เกิดขึ้น ไม่ว่าด้วยเหตุใด และไม่ว่าธนาคารจะทราบเองหรือได้รับแจ้งจากผู้ใช้บริการหรือไม่ก็ตาม  </span></p><p><span>20. ในกรณีที่ผู้ใช้บริการประสงค์ที่จะยกเลิกการใช้บริการตามเงื่อนไขการใช้บริการฉบับนี้ ผู้ใช้บริการจะต้องทำการยกเลิกบริการด้วยตนเองผ่านทาง LINE Messenger และดำเนินการต่างๆ ตามขั้นตอนที่ระบุใน LINE Messenger</span></p><p><span>21. กรณีที่เงื่อนไขการใช้บริการฉบับนี้สิ้นสุดลง ไม่ว่าด้วยเหตุใดๆ ไม่เป็นการยกเลิกภาระหน้าที่ใดๆ ซึ่งผู้ใช้บริการยังปฏิบัติไม่ครบถ้วนตามข้อผูกพันแห่งเงื่อนไขการใช้บริการฉบับนี้ จนกว่าผู้ใช้บริการจะปฏิบัติภาระหน้าที่ดังกล่าวจนครบถ้วนแล้ว</span></p><p><span>22. ในกรณีที่มีเหตุสุดวิสัยหรือเหตุอื่นใดอันทำให้ธนาคารไม่สามารถดำเนินการให้บริการตามเงื่อนไขการใช้บริการฉบับนี้ได้ ผู้ใช้บริการตกลงให้ธนาคารพิจารณาให้บริการ หรือดำเนินการตามที่เห็นสมควร เพื่อให้การให้บริการตามเงื่อนไขการใช้บริการฉบับนี้ได้ โดยผู้ใช้บริการตกลงยินยอมที่จะให้ความร่วมมือแก่ธนาคารอย่างเต็มที่และทุกวิถีทางในการปรับปรุงวิธีการให้บริการของธนาคาร</span></p><p><span>23. การล่าช้า หรืองดเว้นใดๆ ในการใช้สิทธิของธนาคารตามกฎหมายหรือตามเงื่อนไขต่างๆ ตลอดจนคู่มือ ระเบียบ และบันทึกเสียงของธนาคารในระบบโทรศัพท์ ไม่ถือว่าธนาคารสละสิทธิ หรือให้ความยินยอมในการดำเนินการใดๆ แก่ผู้ใช้บริการแต่ประการใด</span></p><p><span>24. ถ้าในเวลาใดก็ตาม เงื่อนไขการใช้บริการฉบับนี้ไม่ว่าข้อหนึ่งข้อใดกลายเป็นโมฆะ ไม่ชอบด้วยกฎหมาย ไม่สมบูรณ์ หรือใช้บังคับมิได้ในประการใด ๆ ให้ข้อกำหนดและเงื่อนไขอื่นๆ ที่เหลือ (แล้วแต่กรณี) ยังคงชอบด้วยกฎหมาย สมบูรณ์ และใช้บังคับได้ตามกฎหมาย และไม่เสียไปเพราะความเป็นโมฆะ ไม่ชอบด้วยกฎหมาย ไม่สมบูรณ์ หรือใช้บังคับมิได้ของเงื่อนไขดังกล่าวนั้น</span></p><p><span>25. เงื่อนไขการใช้บริการฉบับนี้ให้ใช้บังคับและตีความตามกฎหมายไทย และให้ศาลไทยเป็นศาลที่มีเขตอำนาจในการพิจารณาข้อพิพาทที่เกิดขึ้นตามเงื่อนไขการใช้บริการฉบับนี้ </span></p>',
    button_cancel: 'ปฏิเสธ',
    button_confirm: 'ยอมรับ',
    desc: 'กรุณาอ่านข้อกำหนดและเงื่อนไขการใช้บริการ “ขุนทอง”',
    chkConfirm: 'ข้าพเจ้ายอมรับข้อกำหนด และเงื่อนไขการให้บริการข้างต้น',
  },
  medalPage: {
    warning: {
      errorGetImage: 'มีบางอย่างผิดพลาด ไม่สามารถสร้างรูปภาพได้นะ',
    },
    processingImage: 'ขุนทองกำลังประมวลผล รอสักครู่นะครับ',
    share: 'แชร์',
    memberList: {
      quickPrice: 'รางวัล...โอนไว!',
    },
    sharedApp: {
      hashtag: '#KhunThong, #ขุนทอง',
      title: 'ขุนทอง (KhunThong)',
      description:
        'ขุนทอง (KhunThong) - Chatbot เหรัญญิก เพื่อนคู่ใจในการทวงตังค์',
      photoAlt: 'ขุนทอง (KhunThong)',
      share: 'แชร์',
    },
  },
  donationPage: {
    donationFlexAltText: 'ส่งต่อหน่วยรับบริจาคจากขุนทอง',
    donationBy: '#เราจะผ่านไปด้วยกัน',
    donationRemark:
      'ขุนทองขอร่วมโปรโมทการบริจาคให้ทีมแพทย์และโรงพยาบาลที่อยู่แนวหน้าในการต่อสู้กับไวรัส COVID-19 เรียกขุนทองมารับบริจาคได้โดยพิมพ์',
    hightlight: '#covid19',
    donationRemarkBy: ' (ข้อมูลสนับสนุนโดย ธนาคารกสิกรไทย)',
    donation: 'หน่วยรับบริจาค',
    shareButton: 'แชร์ให้เพื่อน',
    cannotShareTargetPicker:
      'ขออภัย! ฟังก์ชันนี้ไม่รองรับ LINE เวอร์ชันต่ำกว่า 10.3.0',
    apiNotAvailable: 'ขออภัย!  LINE ของพี่ไม่รองรับการ “แชร์ให้เพื่อน”',
  },
  donationDestinationInfoPage: {
    mainBtn: 'เลือกวิธีบริจาค',
    note: 'รายละเอียดเพิ่มเติม',
    detail: 'ขอบคุณทุกท่านที่ร่วมฝ่าวิกฤตไปด้วยกัน',
    taxDeduction: 'สิทธิประโยชน์ทางภาษี',
    selectMethod: 'เลือกวิธีบริจาค',
    paymentMethod: {
      kplus: 'บริจาคผ่าน K PLUS',
      qr: 'บริจาคผ่าน QR e-Donation',
    },
  },
  donationPaymentKPlusPage: {
    total: 'จำนวน',
    remark:
      'หมายเหตุ: กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนการบริจาค การบริจาคเงินผ่านช่องทางนี้ มิใช่การบริจาคผ่านระบบ e-Donation ทั้งนี้หากผู้บริจาคต้องการใช้สิทธิ์ลดหย่อนภาษี โปรดนำใบเสร็จจากมูลนิธิยื่นขอลดหย่อนภาษีด้วยตัวเอง',
    nextBtn: 'ดำเนินการต่อด้วย K PLUS',
  },
  donationPaymentQRPage: {
    nextBtn: 'บันทึกรูปภาพ',
  },
  rollcallPage: {
    topic: '#เช็คชื่อ',
    unanswerListTopic: 'คนที่ยังไม่ได้ตอบ',
    answerListTopic: 'คนที่ตอบแล้ว',
    completeButton: 'จบการเช็คชื่อ',
  },
  rewardInfoPage: {
    duration: 'หมดอายุ',
    tabDetail: 'รายละเอียด',
    tabCondition: 'เงื่อนไข',
    claimNow: 'ใช้สิทธิ์ทันที',
    eligibleUntil: 'ใช้ได้ถึง',
  },
  campaignActivityPage: {
    activityEmpty: 'ช่วงนี้ยังไม่มีกิจกรรมอะไรเลยค้าบ~~',
    couponEmpty: 'พี่ยังไม่มีคูปองเลย',
    activityText: 'กิจกรรม',
    couponText: 'คูปองของฉัน',
    couponListInactive: 'คูปองที่ใช้แล้ว / หมดอายุแล้ว',
    couponInactive: 'หมดอายุแล้ว',
    daily: 'วันนี้',
    monthly: 'เดือนนี้',
    weekly: 'สัปดาห์นี้',
    normal: '',
    messageDesc: '{{displayType}}เหลืออีก {{remindLeft}} ชิ้น',
    messageCouponDone: 'คูปองหมดแล้ว',
    messageCouponNotDone: 'คูปองหมดแล้ว รอบใหม่',
    eligibleUntil: 'ใช้ได้ถึง',
    myCoupon: {
      eligibleUntil: 'ใช้ได้ถึง',
    },
  },
  campaignInfoPage: {
    //activity: 'กิจกรรม',
    duration: 'ช่วงเวลากิจกรรม',
    tabDetail: 'รายละเอียด',
    tabCondition: 'เงื่อนไข',
    detailTopic: 'ของรางวัลกิจกรรม',
    messageCouponLeft: '{{displayType}}เหลืออีก {{remindLeft}} ชิ้น',
    messageCouponNotDoneWithType:
      '{{displayType}}หมดแล้ว - คูปองชุดใหม่จะมาวันที่',
    messageCouponNotDone: 'คูปองหมดแล้ว - คูปองชุดใหม่จะมาวันที่',
    messageCouponDone: 'คูปองหมดแล้ว',
  },
  campaignRewardCodePage: {
    placeTheBelowCodeToProceed: 'ใส่โค้ดด้านล่างนี้ เมื่อทำการชำระเงิน',
    eligibleUntil: 'ใช้ได้ถึง',
    code: 'โค้ด',
    qrCode: 'QR Code',
    barCode: 'Barcode',
  },
  campaignRewardMessagePage: {
    eligibleUntil: 'ใช้ได้ถึง',
  },
  rewardPage: {
    headerTextRequester: 'ขอแสดงความยินดี!!!',
    headerTextPayer: 'เพื่อนคุณได้ของขวัญ',
    titleRequesterTemp: 'ที่เก็บเงินเพื่อนๆด้วยขุนทองสำเร็จ',
    getRewardAlready: 'พี่ได้ร่วมกิจกรรมนี้ไปแล้ว',
    //titlePayerTemp: 'ในกิจกรรม: พาขุนทองรู้จักเพื่อนใหม่',
    titleExpried: 'กิจกรรมนี้หมดเขตแล้วจ้าา~',
    btnNextCoupon: 'ไปที่คูปองของฉัน',
    btnNextActivity: 'ร่วมกิจกรรมเพื่อรับคูปอง',
    checkNewCamp: 'เช็คกิจกรรมล่าสุด',
  },
  imageListDialog: {
    title: 'เลือกไอคอน',
    select: 'เลือก',
    cancel: 'ยกเลิก',
  },
  scheduleCreatePage: {
    title: 'สร้างบิลรายเดือนเพิ่ม',
    titleDescription: 'น้องคัดมาให้แล้ว พี่เก็บประมาณนี้หรือเปล่า?',
    reachMaxScehdule:
      'น้องเก็บบิลรายเดือนได้สูงสุด<br/>กลุ่มละ {{maxScheduleBillsInGroup}} บิล',
    noBill1:
      'น้องเก็บบิลรายเดือนได้สูงสุด {{maxScheduleBillsInGroup}} บิลต่อกลุ่ม',
    noBill2: 'กรุณาเคลียร์บิลเก่าก่อนเรียกเก็บเพิ่มเติมนะค้าบ ~',
    scheduleBill: 'บิลรายเดือน',
  },
  scheduleAssignPage: {
    scheduleName: 'กรอกชื่อบิล',
    startDate: 'เริ่มเก็บ',
    total: 'ยอดรวมครั้งละ',
    totalByTotal: 'ยอดรวม',
    totalPerEach: 'เก็บคนละ',
    totalAll: 'ยอดรวมบิล ({{personNo}} คน) เป็นเงิน ฿ {{total}}',
    memberHeader: 'ยอดแต่ละคน ({{personNo}} คน)',
    memberHeaderPerEach: 'เก็บใครบ้าง ({{personNo}} คน)',

    addAccount: 'เพิ่มบัญชี หรือพร้อมเพย์',
    account: 'บัญชีรับเงิน:',
    promptpay: 'พร้อมเพย์',

    btnSave: 'บันทึกบิลรายเดือน',
    memberEmptyNotAllow: 'จำนวนสมาชิกต้องมีอย่างน้อย 1 คน',
    accountEmptyNotAllow: 'คุณยังไม่ได้เลือกบัญชีรับเงิน',
    btnAddAccount: 'เพิ่มบัญชีรับเงิน',
    errorMsg: 'ข้อมูลบางอย่างไม่ถูกต้อง',

    memberList: {
      collectingInterval: 'เก็บซ้ำทุก',
    },
  },
  scheduleSummaryPage: {
    //billCanceled:
    //  '<b>บิลนี้ยังเก็บไม่ครบเลย</b><br/>พี่แน่ใจเหรอว่าจะให้น้องขุนลบจริงๆ',
    billCanceledFromFlex:
      '<b>รายการเรียกเก็บรายเดือน</b><br/>พี่แน่ใจเหรอว่าจะให้น้องขุนลบจริงๆ',
    billEdited:
      '<b>คำเตือนการแก้ไขบิล</b><br/>การแก้ไขจะมีผลในรอบบิลถัดไป<br/>หากมีผู้จ่ายแล้วจะถูกเรียกเก็บใหม่น้าา~',
    btnEditBillOkay: 'แก้ไขบิล',
    billTypeM1: 'เดือน',
    billTypeW1: 'สัปดาห์',
    billTypeWeek: '{{number}} สัปดาห์',
    billTypeMonth: '{{number}} เดือน',
    billTypeM12: 'ปี',
    nextPeriod: 'รอบถัดไป',
    remainingTotal: 'ยอดค้างจ่าย',
    editBill: 'แก้ไขบิล',
    cancelBill: 'ยกเลิกการเก็บเงิน',
    cancelScheduleBill: 'ยกเลิกรายการเรียกเก็บรายเดือน',
    periodDate: 'รอบวันที่',
    period: 'รอบที่',
    billNoActive: 'ยังไม่เริ่มเรียกเก็บ เพราะมีบิลที่ยังค้างอยู่',
    paymentTransBottom: {
      amount: 'ยอดเงิน',
      baht: 'บาท',
    },
    notTheOwner:
      '<b>ขออภัย! บิลนี้ไม่ใช่ของพี่</b><br/>ไม่สามารถยกเลิกบิลได้ครับ',
    repeatTimeText1: 'ไม่มีจุดสิ้นสุด',
    repeatTimeText2: 'เก็บ {{number}} ครั้ง',
    durationText1: 'เก็บทุก{{time}}',
    durationText2: 'เก็บทุก {{number}} {{time}}',
    month: 'เดือน',
    week: 'สัปดาห์',
    expireText: 'หมดอายุ',
    completeText: 'สิ้นสุด',
  },
  scheduleTimeSettingPage: {
    billName: 'กรอกชื่อบิล',
    scheduleDate: 'วันที่เริ่มเก็บ',
    scheduleTime: 'เตือนเวลา',
    remark:
      'หมายเหตุ: หากเดือนใดไม่มีวันที่เลือกไว้ (เช่น 29,30,31) ขุนทองจะเตือนในวันสิ้นเดือนของเดือนนั้นแทน',
    remarkEndDate: ' บิลรอบสุดท้าย',
    minDateMessage: 'วันที่เริ่มเก็บต้องมากกว่าวันปัจจุบัน',
    maxDateMessage: 'วันที่เริ่มเก็บต้องไม่เกิน 1 ปี',
    invalidDateMessage: 'วันที่เริ่มเก็บไม่ถูกต้อง',
    durationSelectListTitle: 'เก็บซ้ำทุก',
    repeatTimeSelectListTitle: 'สิ้นสุด',
    durationUnit: 'เก็บซ้ำทุก {{number}} {{time}}',
    month: 'เดือน',
    week: 'สัปดาห์',
    now: 'ตอนนี้',
  },
  repeatTimeSelectList: {
    repeatTimeNoUnit: 'ไม่มีจุดสิ้นสุด',
    repeatTimeUnit: 'เก็บทั้งหมด {{number}} ครั้ง',
  },
  durationSelectList: {
    monthUnit: '{{number}} {{time}}',
    month: 'เดือน',
    week: 'สัปดาห์',
  },
  iframeToKplus: {
    goingToKplus: 'กำลังไปที่ K PLUS',
  },
  imagePage: {
    slogan: 'ขุนทอง (KhunThong) - Chatbot เหรัญญิก เพื่อนคู่ใจในการทวงตังค์',
  },
  imageHero: {
    groupHost: 'เจ้ามือประจำกลุ่ม',
    createBill: 'สร้างบิล',
    times: 'ครั้ง',
  },
  billFlex: {
    paidMemberTitle: 'จ่ายแล้ว',
    unpaidMemberTitle: 'ยังไม่ได้จ่าย',
    verifyPaidWithCashTitle: 'รอตรวจสอบ',
    detailBtn: 'ดูรายละเอียด',
    owner: 'เรียกเก็บโดย',
    followButton: 'ส่งบิลเข้ากลุ่มหน่อย',
    deleteButton: 'ยกเลิกเก็บเงิน',
    deleteButton2: 'ลบเลย',
    schedulePeriod: 'รอบวันที่',
    scheduleDeleteAll: 'ลบบิลรายเดือนทั้งหมด',
    scheduleDelete: 'ลบเฉพาะบิลเดือนนี้',
    rogerThat: 'ยืนยัน',
    remindPopup:
      '<b>ส่งบิลเข้ากลุ่มหน่อย</b><br/>ต้องการเรียกเพื่อนๆมาจ่ายบิล?',
    moreMember: 'และอีก {{numberMember}} คน...',
    numberMember: '({{numberMember}} คน)',
    cannotRemindBill: 'ขออภัย! ไม่สามารถส่งบิลเข้ากลุ่มได้',
    deleteStatusNewDetail: 'บิลนี้พี่ยังสร้างไม่เสร็จ',
  },
  billSummary: {
    billWaitingTab: 'บิลรอคุณจ่าย',
    allBillTab: 'รายการทั้งหมด',
    myBill: 'บิลของฉัน',
    friendBill: 'บิลของเพื่อนในกลุ่ม',
    noBill: 'คุณพี่ไม่มีบิลค้างจ่ายค้าบ~~',
    loadingCrop: `กำลังรวมบิลอยู่ค้าบ~`,
    loadingAction: `กำลังดำเนินการอยู่ค้าบ~`,
    scheduleBill: 'แผนที่สร้างไว้',
  },
  InviteMoreFriendPage: {
    header: 'เพิ่มคนนอกกลุ่ม',
    placeholderInputFriend: 'กรอกชื่อเพื่อน',
    headerParentName: 'เลือกเพื่อนที่พามา',
    //parentName: 'เพื่อนที่พามา',
    cameWith: 'มากับ',
    comeWith: ' (@{{name}})',
  },
  statusNewVerifyFlex: {
    noUse: 'ไม่ใช้แล้ว',
    continueCreateBill: 'สร้างบิลต่อ',
    finalizeBill: 'สรุปบิล',
    assignYourself: 'เลือกรายการ',
    checkYourself: 'ตรวจสอบ',
    addAccountNo: 'เพิ่มเลขบัญชี',
    allSelectedList: 'ทุกคนเลือกรายการที่จะจ่ายครบแล้ว',
    readyToSummaryBill: 'พร้อมสรุปบิลแล้วจ้าาา',
    noAccountNo: 'บิลของพี่ยังไม่ได้ใส่เลขบัญชีขารับ',
    noSelectList: 'ยังมีคนไม่ได้เลือก รายการไหนของใครบ้าง?',
  },
  paidByCashWaitingFlex: {
    waitingPaidWithCash: 'รอตรวจสอบ: คนที่จ่ายด้วยเงินสด',
  },
  autoDeleteFlex: {
    outstandingBill:
      'บิลกำลังจะหมดอายุ... แต่น้องยังเก็บให้ไม่สำเร็จเรียกเก็บต่อกด "ยังใช้อยู่จ้า" ได้เลยค้าบ แต่ถ้าพี่ไม่ใช้แล้วน้องขออนุญาตลบบิลในอีก {{dayUntilAutoCancel}} วันนะค้าบบบ',
    stillUse: 'ยังใช้อยู่จ้า',
    deleteNow: 'ลบเลย',
  },
  paymentFlex: {
    pay: 'จ่ายเงิน',
    total: 'รวมทั้งหมด',
    confirmPay: 'ยืนยันการจ่ายเงิน',
  },
  // slipVerifyFlex: {
  //   waitingForVerify: 'รอตรวจสอบ: คนที่ยืนยันว่าจ่ายแล้ว',
  //   watchSlip: 'ดูสลิป',
  //   wrongAccountNo:
  //     'เนื่องจากโอนมาไม่ตรงกับบัญชีเรียกเก็บบัญชีนี้ใช่ของคุณพี่หรือเปล่า?',
  //   yesAlreadyGotMoney: 'ใช่, ได้เงินแล้ว',
  // },
  paymentBySlipPage: {
    header: 'สลิปนี้จ่ายค่าอะไร?',
    headerLabel: 'ยอดโอนรวม:',
    pleaseTellMe: 'ข้อมูลการโอนจากสลิปนี้ยังส่งมาไม่ถึง',
    pleaseTellMe2: 'พี่โอนมาบิลไหน ช่วยบอกน้องหน่อยนะ',
    //confirmPayTitle: 'พี่ได้ตรวจสอบว่าได้รับเงินตรงตามสลิปแล้ว',
    confirmSlipErrorType: {
      notOwner:
        '<b>ขออภัย! บิลนี้ไม่ใช่ของพี่</b><br/> ไม่สามารถดำเนินการได้จ้าา~',
      slipConfirmed:
        '<b>ขออภัย! พี่จ่ายบิลนี้ไปแล้ว</b><br/> ไม่สามารถดำเนินการได้จ้าา~',
      notFound:
        '<b>ขออภัย! บิลนี้ปิด หรือ มีการทำรายการไปแล้ว</b><br/> ไม่สามารถดำเนินการได้จ้าา~',
    },
  },
  tablet: {
    notSupportTablet:
      'ไม่สามารถใช้ขุนทองในแท็บเล็ตได้ แต่ใช้กับมือถือของพี่ได้นะครับ',
  },
  cancelInfo: {
    cancelBillTitle: 'เลือกบิลที่จะลบ',
    cancelBillInfo: 'มีบิลที่ยังเก็บไม่ครบ พี่จะลบจริงๆเหรอ?',
    noBill: 'คุณพี่ไม่มีบิลให้ลบค้าบ~~',
  },
  confrimPaidBySlipFlex: {
    waitingForVerify: 'รอตรวจสอบ: ยอดเงินบนสลิป',
    waitingForVerifyAcc: 'รอตรวจสอบ: บัญชีรับเงิน',
    SentwaitingForVerify: 'บอกว่าจ่ายแล้ว {{total}} บาท',
    SentwaitingForVerifyOwner: 'บอกว่าจ่ายแล้ว {{total}} บาท ดูสลิปด้วยน้าา~',
    SentwaitingForVerifyAcc: 'โอนมาไม่ตรงกับบัญชีที่เรียกเก็บ',
    SentwaitingForVerifyAccOwner:
      'โอนมาไม่ตรงกับบัญชีที่เรียกเก็บ บัญชีนี้ใช่ของคุณพี่หรือเปล่า?',
    watchSlip: 'ดูสลิป',
    listOfWaitingForConfrim: 'บิลที่เลือกจ่าย',
    total: 'ยอดรวม',
    totalSlip: 'ยอดที่โอนมา:',
    confrimQuest: 'พี่ได้รับเงินตรงกับยอดรวมแล้ว?',
    notGetMoneyQuest: 'คุณพี่ยังไม่ได้รับเงิน?',
    yesAlreadyGotMoney: 'ใช่, ได้เงินแล้ว',
    //close: 'ปิด',
    remindPopupUnselected: '<span>โปรดเลือกบิลที่ต้องการจ่าย</span>',
    remindPopupSelected:
      '<b>โปรดเลือกบิลที่ต้องการจ่ายเพิ่ม</b><br/><span>สลิปที่โอนยังเหลือมูลค่าอีก {{amount}} บาท</span>',
    rogerThat: 'รับทราบ',
    rejectPopupTypeError1:
      'คุณพี่ยืนยันว่า ยังไม่ได้รับเงิน หรือ ได้รับเงินไม่ครบ',
    rejectPopupTypeError2: 'คุณพี่ยืนยันว่า ยังไม่ได้รับเงิน',
    confirmPopup: 'คุณพี่ตรวจสอบว่าได้รับเงินแล้ว',
  },
  pdpaPage: {
    nextBtn: 'ยืนยัน',
    pdpaHeader1: 'ความยินยอมให้ธนาคารพัฒนาผลิตภัณฑ์หรือบริการให้ดียิ่งขึ้น',
    pdpaHeader2: 'ความยินยอมให้ธนาคารนำเสนอผลิตภัณฑ์หรือบริการ',
    pdpaHeader3:
      'ความยินยอมให้กลุ่มธุรกิจทางการเงิน และพันธมิตร ทางธุรกิจนำเสนอผลิตภัณฑ์หรือบริการ',
    acceptedAllButton: 'ยินยอมทั้งหมด',
    manualAllButton: 'กำหนดเอง',
  },
  transferSlipPage: {
    selectOtherImage: 'เลือกรูปอื่น',
    confirmButton: 'ยืนยัน e-Slip',
    popupNoQRCode:
      '<b>กรุณาอัพโหลด e-Slip ที่มี QR Code</b><br/><span>หรือติดต่อเจ้าของบิลเพื่อตรวจสอบให้ค้าบ</span>',
    popupOldSlip:
      '<b>สลิปนี้เก่าไป!</b><br/><span>คุณพี่ต้องโอนหลังจากที่เริ่มเรียกเก็บ</span>',
    popupDuplicate:
      '<b>น้องเคยเห็นสลิปนี้แล้ว!</b><br/><span>สลิปนี้ถูกใช้ไปแล้ว</span>',
    popupError:
      '<b>ขออภัยในความไม่สะดวก</b><br/><span>รบกวนคุณพี่เลือกจ่ายเงินด้วยวิธีอื่น</span>',
    popupNotEnoughAmount:
      '<b>ขออภัยในความไม่สะดวก</b><br/><span>รบกวนคุณพี่ส่งสลิปเข้าไปในแชทแทนครับ</span>',
    popupBillCancel:
      '<b>บิลที่พี่เลือกถูกยกเลิกไปแล้ว</b><br/><span>รบกวนคุณพี่ตรวจสอบรายละเอียดบิล</span>',
    popupBillPaid:
      '<b>น้องว่าพี่จ่ายไปแล้วนะ</b><br/><span>รบกวนคุณพี่ตรวจสอบรายละเอียดบิล</span>',
    tryAgain: 'ลองตรวจใหม่',
    close: 'ปิด',
    confirm: 'ตกลง',
  },
  HowToPage: {
    header: {
      left: 'การใช้งาน',
      right: 'เบื้องต้น',
    },
    step1: {
      stepName: '1) Add ขุนทองเป็นเพื่อน',
      stepDesc:
        'โดยพี่ๆแค่ Add LINE ID: @KhunThong หรือเพียง Add น้องจากกลุ่มเพื่อนที่พี่มีอยู่แล้ว',
    },
    step2: {
      stepName: '2) ชวนขุนทองเข้ากลุ่ม',
      stepDesc:
        'แค่กดปุ่ม Invite จากกลุ่ม LINE ที่อยากชวนน้องเข้าไป แล้วเลือก "KhunThong (ขุนทอง)" จากรายชื่อเพื่อน',
      bodyStep: {
        step1: 'เลือก Invite',
        step2: 'เลือกขุนทองเลย',
      },
      footerStep: {
        text1: 'ขุนทองตัวจริงต้องมี',
        text2: 'โล่ดำแบบนี้นะค้าบบ',
      },
    },
    step3: {
      stepName: '3) การสร้างบิล',
      stepDesc:
        'แค่พี่ลองพิมพ์ "ขุนทอง" ในกลุ่ม LINE ที่ต้องการเรียกเก็บเงิน แล้วเลือก "สร้างบิล" หลังจากนั้นเลือกว่าเก็บเงินใครบ้าง ใส่จำนวนเงิน ใส่เลขบัญชีขารับ และสุดท้ายส่งบิลเข้ากลุ่ม',
    },
    step4: {
      stepName: '4) การจ่ายเงิน',
      stepDesc:
        'ถ้ามีใครเรียกเก็บเงิน น้องก็จะส่งสรุปบิลเข้ามาให้ทุกคนได้จ่ายเงิน ซึ่งพี่สามารถกด “จ่ายเงิน” แล้วเลือกวิธีการจ่ายเงิน ที่ต้องการ เมื่อมีการจ่ายเงินเข้ามา น้องก็จะตรวจสอบให้ว่า ใครจ่ายครบแล้วบ้าง ซึ่งพี่สามารถกด “ดูว่าใครจ่ายแล้ว” เพื่อดูสรุปว่าเหลือใครบ้างที่ยังไม่ได้จ่าย',
    },
    step5: {
      stepName: '5) ตามเก็บเงิน',
      stepDesc:
        'ถ้าหากมีใครลืมจ่ายเงิน ขุนทองจะส่งข้อความเตือนเข้าไปในกลุ่ม ตอน 10 โมงเช้าของทุกวัน จนกว่าทุกคนจะจ่ายเงินครบ',
    },
  },
  FAQPage: {
    header: {
      title: '[คำถามที่พบบ่อย]',
    },
    step1: {
      stepName: '1) ขุนทองคือใคร เป็นอะไรกับ KBank',
      stepDesc:
        '“ขุนทอง” คือ Chatbot เหรัญญิก เพื่อนคู่ใจในการเรียกเก็บเงินจากธนาคารกสิกรไทย เพื่ออำนวยความสะดวกทั้งผู้จ่ายและผู้เรียกเก็บเงิน ช่วยให้สมาชิกในกลุ่ม LINE ไม่ว่าจะใช้ธนาคารไหนก็สามารถจัดการ Request to Pay ได้อย่างสะดวกและรวดเร็ว',
    },
    step2: {
      stepName: '2) ขุนทองแอบอ่าน Chat ไหม',
      stepDesc:
        'ขุนทองไม่มีการเก็บข้อมูลการสนทนาใดๆไว้ ส่วนที่เก็บไว้จะเป็นข้อมูลที่เกี่ยวข้องกับบริการ เช่น คำสั่งเฉพาะ “เก็บเงิน“ หรือ ประโยคที่มี “ขุนทอง“',
    },
    step3: {
      stepName: '3) เชิญขุนทองเข้ากลุ่มไม่สำเร็จ ติดสถานะ Pending',
      stepDesc:
        'เนื่องจากทาง LINE อนุญาตให้มี LINE Official Account ได้แค่ 1 account ต่อ 1 กลุ่ม ทำให้ LINE Official Account ตัวที่ 2 ไม่สามารถเข้ากลุ่มได้',
    },
    step4: {
      stepName: '4) ชื่อสมาชิกขึ้นไม่ครบตอนสร้างบิลทำไง',
      stepDesc:
        'ให้กดปุ่ม refresh ตำแหน่งขวาบนสุด ของหน้าจอที่ใช้เลือกว่าเก็บเงินใครบ้าง',
    },
    step5: {
      stepName: '5) ลบขุนทองออกจากกลุ่ม',
      stepDesc: 'ลบขุนทองออกจากกลุ่ม – พิมพ์ #ขุนทองออกไป',
    },
    step6: {
      stepName: '6) วิธีสังเกตคนแอบอ้างเป็นขุนทอง',
      stepDesc1: 'ขุนทองตัวจริงเป็น official account ที่มี',
      stepDesc2:
        'โล่ดำอยู่หน้าชื่อโปรไฟล์ และขุนทองตัวจริงจะมี LINE ID “@KhunThong“ เท่านั้น หากมีขุนทองตัวจริงอยู่ในกลุ่ม พี่ๆ จะสามารถเรียก “ขุนทอง” ออกมาเก็บเงินได้เสมอ',
    },
  },
  PDPAPage: {
    Approve: 'ยินยอม',
    Unapprove: 'ไม่ยินยอม',
    PDPA: 'การจัดการข้อมูลส่วนบุคคล',
  },

  redeemLocationCodePage: {
    headerText0: '#กรอกโค้ด',
    headerText1: 'แลกรางวัล',
    description: 'กรอกโค้ดโปรโมชั่น',
    button: 'รับสิทธิ์',
    remindText:
      'กรุณาอนุญาตการเข้าถึงตำแหน่งที่ตั้ง เพื่อตรวจสอบเงื่อนไขการได้รับรางวัล',
    placeHolder: 'Referal Code / Promo code',
    errorText: {
      locationDenied: 'กรุณาอนุญาตการเข้าถึงตำแหน่ง',
      invalidCode: 'ขออภัยโค้ดไม่ถูกต้อง โปรดตรวจสอบอีกครั้ง',
      tooFar: 'การรับสิทธิ์ต้องอยู่บริเวณร้าน',
      fullyRedeemed: 'วันนี้คูปองหมดแล้ว',
      alreadyRedeemed: 'คุณพี่ได้ใช้สิทธิ์ไปแล้วค้าบบ',
      unknownError: 'มีข้อผิดพลาด รบกวนคุณพี่ลองใหม่อีกครั้งครับ',
    },
    errorPopup: {
      locationDenied: {
        text: '<b>กรุณาอนุญาตการเข้าถึงตำแหน่ง</b><br />แอป LINE ผ่านเมนูตั้งค่า เพื่อการรับสิทธิ์',
        buttonOk: 'ตกลง',
      },
      tooFar: {
        text: '<b>การรับสิทธิ์ต้องอยู่บริเวณร้าน</b><br />เข้าใกล้ร้านกว่านี้อีกนิดแล้วกดใหม่นะค้าบบ',
        buttonBack: 'ย้อนกลับ',
        buttonMap: 'ดูแผนที่',
      },
    },
  },
  NotKhunthongFriendPage: {
    addFriendKhunthong: 'Add Friend @KhunThong',
    pleaseAddFriendKhunthong: 'กรุณาเพิ่มขุนทองเป็นเพื่อน',
    beforeUse: 'ก่อนเริ่มใช้งาน',
    startToUseKhunthong: 'เริ่มต้นใช้งานขุนทอง',
  },
  WarmWelcomPage: {
    addFriendKhunthong: 'เริ่มต้นใช้งานขุนทอง',
    backToChatAndCreateBill: 'กลับไปสร้างบิลในแชท',
    inviteFriend: 'ชวนเพื่อนรับสูงสุด {{cashbackLimit}} บาท',
    whoIsKhunthong: 'ขุนทองคือใคร?',
    introduceKhunthong: `แชทบอทเหรัญญิกประจำกรุ๊ปไลน์ จากธนาคาร กสิกรไทย
    ที่จะมาช่วยคำนวณค่าใช้จ่ายและเรียกเก็บเงิน จะไปเที่ยวไหนทำอะไร
    ก็แชร์ได้แฟร์ๆ สะดวกทั้งผู้จ่าย และผู้เรียกเก็บเงิน
    ไม่ว่าจะใช้ธนาคารไหนก็ใช้ได้`,
    invite: 'Invite เข้าใน',
    groupLine: 'กรุ๊ปไลน์',
    createBill1: 'มื้อนี้บิลออกมา 1,256 บาท แค่พิมพ์',
    createBill2: ' “ขุนทอง” ',
    createBill3: 'ในกรุ๊ปแล้วเลือก “สร้างบิล”',
    assignTotal: 'ใส่ยอดรวมบิล',
    editAmount: 'แก้ยอดแต่ละคนได้ด้วยนะ',
    pay: 'จ่ายได้ทุกธนาคาร',
    sendBill: `ขุนทองจะส่งสรุปบิลเข้ามาในแชทกลุ่ม
    ทุกคนสามารถกด “จ่ายเงิน” ได้ทันที แล้วเลือก
    วิธีการจ่ายเงินที่ต้องการได้เลย`,
    specialActivity: 'กิจกรรมพิเศษ!',
  },
  startRegisterPage: {
    startKTH: 'เริ่มใช้ขุนทอง',
    subTitleKTH: 'แชทบอทเหรัญญิกประจำกรุ๊ปไลน์',
    inviteKTH: 'Invite “ขุนทอง”',
    toGroupLine: 'เข้ามาใน “กรุ๊ปไลน์” ก่อน',
    addFriendKhunthong: 'เริ่มใช้งานขุนทอง',
    inviteFriend: 'ชวนเพื่อนรับสูงสุด {{cashbackLimit}} บาท',
    whoIsKhunthong: 'ขุนทองคือใคร?',
    introduceKhunthong: `แชทบอทเหรัญญิกประจำกรุ๊ปไลน์ จากธนาคาร กสิกรไทย
    ที่จะมาช่วยคำนวณค่าใช้จ่ายและเรียกเก็บเงิน จะไปเที่ยวไหนทำอะไร
    ก็แชร์ได้แฟร์ๆ สะดวกทั้งผู้จ่าย และผู้เรียกเก็บเงิน
    ไม่ว่าจะใช้ธนาคารไหนก็ใช้ได้`,
    invite: 'พิมพ์ “ขุนทอง” ในกรุ๊ปไลน์',
    groupLine: 'เพื่อเรียกมาช่วยเก็บเงิน',
    createBill1: 'มื้อนี้บิลออกมา 1,256 บาท แค่พิมพ์',
    createBill2: ' “ขุนทอง” ',
    createBill3: 'ในกรุ๊ปแล้วเลือก “สร้างบิล”',
    assignTotal: 'ใส่ยอดรวมบิล',
    editAmount: 'ขุนทองหารให้ ปรับยอดได้ด้วยนะ',
    pay: 'บิลพร้อมจ่ายแล้ว',
    sendBill1: 'รอเพื่อนๆ มากด “จ่ายเงิน”',
    sendBill2: 'เลือกวิธีการจ่ายเงินที่ต้องการ ได้เลย',
    specialActivity: 'กิจกรรมพิเศษ!',
    firstAddAccount: 'ตั้งค่าบัญชีรับเงินครั้งแรก',
    saveAccount1: 'บันทึกเลขบัญชีสำหรับรับหรือจ่ายเงิน',
    saveAccount2: 'ขุนทองเรียกเก็บให้ ใช้ได้ทุกธนาคารนะ',
    plusAddAccount: 'ตั้งค่าบัญชีรับ-จ่าย',
    remind1: '“ลืมจ่าย” ก็เตือนให้',
    remind2: 'ช่วยเตือนทุกวัน จนกว่าเพื่อนจะจ่าย',
    otherBill1: 'บิลแบบอื่น น้องก็เก็บได้~',
    otherBill2: 'บิลรายเดือน',
    otherBill3: 'เรียกเก็บเงินแบบส่วนตัว',
  },
  referreeError: {
    pleaseAddKhunthong: 'กรุณาเพิ่มขุนทองเป็นเพื่อนก่อน',
    referrerDataNotFound: 'เกิดข้อผิดพลาด ไม่พบข้อมูลของผู้เชิญ',
    alreadyKhunthongFriend:
      'พี่เคยเป็นเพื่อนกับขุนทองทองแล้วครับ ชวนเพื่อนคนอื่นต่อได้เลย!',
  },
  referral: {
    instructionPage: {
      activityDuration: 'ช่วงเวลากิจกรรม',
      conditionTitle: 'เงื่อนไขการร่วมสนุก',
      registerKhunThongTitle:
        '<b>ผูกบัญชีกับบริการขุนทอง</b><br/>เพื่อเริ่มชวนเพื่อนและใช้งานขุนทอง',
      registerKhunThongConfirm: 'ผูกบัญชีกับขุนทอง',
      registerKhunThongBack: 'ย้อนกลับ',
      backChatBtn: 'กลับสู่ Chat',
      newActivitySoon: 'พบกิจกรรมใหม่ได้เร็วๆนี้นะค้าบบ~',
      newCampaignSoon: 'แคมเปญจะกลับมาใหม่เร็ว ๆ นี้',
      campaignEnded: 'สิ้นสุดแคมเปญ',
      bindAccountUsingKplus: 'ผูกบัญชีกสิกรไทยผ่าน K PLUS',
      termAndConditionTitle: 'รายละเอียดและเงื่อนไขกิจกรรม',
    },
    termAndCondition: {
      title: 'เงื่อนไขการร่วมกิจกรรม',
    },
    sharePreviewPage: {
      description: 'ตัวอย่างข้อความที่จะแชร์ให้เพื่อน',
      shareFriend: 'แชร์ให้เพื่อน',
    },
    successPage: {
      invited: 'ส่งคำเชิญเรียบร้อยแล้ว',
      description:
        'รอเพื่อนของพี่ มากดเพิ่มขุนทองเป็นเพื่อน\nแล้วอย่าลืมเข้ามาดูยอดเงิน Cashback ของพี่นะ',
    },
    referralCard: {
      yourCashback: 'ยอด Cashback ของคุณ',
      remainingDay: 'เหลืออีก {{day}} วัน',
      startToInviteYourFriend: 'เริ่มชวนเพื่อนเลย',
      inviteMoreFriend: 'ชวนเพื่อนเพิ่ม',
      cashbackPrice: '{{price}} บาท',
      target: 'เป้าหมาย {{price}} บาท',
      addBankAccout: '+ เพิ่มบัญชีรับเงิน',
      cashbackAccount: 'บัญชีรับเงินรางวัล:',
      accountNumber: 'เลขบัญชี: {{number}}',
      gotMoneyTitle: 'ขุนทองโอนเงินรางวัลจากกิจกรรม สำเร็จ!',
      txnDate: 'วันที่ทำรายการ',
      topOfTheSocialist: 'สุดยอดแห่งสายโซเชียล',
      youHaveCompleteReferred:
        'ขอบคุณที่ชวนเพื่อนมารู้จักขุนทองครบ {{limit}} คนแล้ว!',
      activityEnded: 'กิจกรรมจบแล้ว',
      thanksForParticipation: 'ขอบคุณที่มาร่วมสนุกกับขุนทองครับบ~',
      outOfQuota: 'เนื่องจากมีผู้ใช้สิทธิ์เต็มจำนวนโอกาสหน้าเจอกันใหม่ค้าบ~',
      yourRewardAmount: 'ยอดเงินรางวัลของคุณ',
    },
  },
  createBillTemplate: {
    whichBillToCreate: 'สร้างบิลแบบไหนดี~',
    splitByAmount: 'หาร/เรียกเก็บเงิน',
    letMeHelpAmountOfWhom: 'น้องคิดเฉลี่ยให้<br/>แต่พี่แก้ยอดได้ค้าบ',
    takeReceiptPicture: 'แยกตามรายการ (ถ่ายรูป)',
    letMeHelpYouRead: 'ถ่ายใบเสร็จ<br/>น้องพิมพ์ชื่อและราคาให้ค้าบ',
    fillYourAmountManually: 'แยกตามรายการ (พิมพ์)',
    splitItemsLikeAnExcel: 'ใส่รายการและราคาได้เองค้าบ',
    monthlyBill: 'บิลแบบรายเดือน',
    makeAScheduleNoMoreForget: 'ตั้งการเรียกเก็บล่วงหน้า เตือนทุกเดือนไม่มีลืม',
    otherBills: 'บิลรูปแบบอื่นๆ',
    seeScheduleBill: 'ดูบิลรายเดือน',
  },
  tutorialTemplate: {
    howToUse: 'วิธีใช้งาน',
    basicUsage: 'การใช้งานเบื้องต้น',
    faq: 'คำถามที่พบบ่อย',
    shortcut: 'คีย์ลัดและเมนูเพิ่มเติม',
  },
  shortkeyPage: {
    header: {
      left: 'คีย์ลัด',
      right: 'และเมนูเพิ่มเติม',
    },
    kthTitle: 'ขุนทอง',
    kthDetail:
      'เรียกขุนทองเพื่อใช้งานในกลุ่ม หรือ ห้องสนทนาที่มีขุนทองอยู่…อย่าลืมเชิญขุนทองเข้ากลุ่มก่อนใช้งานน้าา~',
    requestMoney: '#เก็บเงิน',
    requestMoneyDetail:
      'คำสั่งลัดในการสร้างบิล โดยมี 2 แบบคือ 1.ให้หารให้ด้วย เช่น “#เก็บเงิน ค่าข้าวเที่ยง ทั้งหมด 100 บาท @ชื่อเพื่อน1 @ชื่อเพื่อน2” หรือ 2. เก็บยอดแต่ละคน เช่น “#เก็บเงิน ค่าข้าวเที่ยง คนละ 100 บาท @ชื่อเพื่อน1 @ชื่อเพื่อน2”',
    schedule: '#เก็บรายเดือน',
    scheduleDetail:
      'คำสั่งลัดในการตั้งบิลเรียกเก็บล่วงหน้าแบบรายเดือน หรือ รายสัปดาห์ เหมาะกับการหารค่า Family Plan ต่างๆ ไม่ว่าจะเป็น Netflix, Youtube, Spotify หรือจะเป็น ค่าเช่า, เงินกลุ่ม, เก็บเงินเพื่อผ่อนซื้อของ ก็ทำได้ง่าย',
    multipleBill: '#เปิดโหมดหลายบิล',
    multipleBillDetail:
      'คำสั่งในการเปิดโหมดหลายบิลให้กลุ่มของคุณพี่สร้างบิลได้อย่างจุใจ รองรับการสร้างบิลแบบหลายบิล',
    currency: '#ค่าเงิน',
    currencyDetail:
      'ดูอัตราค่าแลกเปลี่ยนเงินต่างประเทศได้จาก Rate ของบัตรเดบิต Journey ถ้าพี่จะคิดเงินเพื่อนๆ ตอนไปเที่ยวต่างประเทศลองใช้ดูนะครับ',
    medal: '#เหรียญรางวัล',
    medalDetail:
      'สรุปลำดับเหรียญรางวัล และมงกุฎ ของทุกคนในกลุ่ม LINE นั้นครับ เอาไว้ขิงเพื่อนว่าพี่นี้สายโอนไว',
    leave: '#ขุนทองออกไป',
    leaveDetail: 'คำสั่งในการเชิญน้องออกจากกลุ่ม LINE ของพี่ๆครับ',
    delete: '#deleteaccount',
    deleteDetail:
      'ลบข้อมูลบัญชีขารับเงิน โดยให้พี่ๆ พิมพ์ในแชทส่วนตัวกับขุนทองครับ',
    footer:
      'ถ้าพี่เหงาหรือไม่มีคนคุยด้วย พี่มาคุยเล่นกับน้องได้ทุกเรื่องเลยนะ ไม่ว่าจะถามน้องว่า “ขุนทองกินไหนดี”, จะให้น้องชมพี่หรือเพื่อนพี่ “ขุนทองชม...” ก็ได้นะครับ',
  },
  inviteKTHPage: {
    inviteKTH: 'Invite “ขุนทอง”',
    inviteKTH2: 'เข้าในกรุ๊ปไลน์ก่อน',
    click: 'กด',
    inLineGroup: 'ใน LINE กลุ่ม',
    selectInvite: 'เลือก Invite',
    typeKTH: 'พิมพ์ “ขุนทอง” เลย!',
    realKTH: 'ขุนทองตัวจริงต้องมี',
    blackShield: 'โล่ดำด้วยนะ~',
  },
  billCenterPage: {
    request: 'เรียกเก็บเงิน',
    inGroup: 'ในกรุ๊ปไลน์',
    sendPrivate: 'ส่งบิลส่วนตัว',
    sendPrivateChat: 'ส่งบิลใน Chat ส่วนตัว',
    createNew: 'สร้างบิลใหม่',
    privateBillHistory: 'ประวัติบิลเรียกเก็บส่วนตัว',
    tryOne: 'ลองใช้เลย',
    groupHistoyr: 'ประวัติบิลกลุ่ม',
    waitForPay: 'รอจ่าย {{number}} คน',
    noBill: 'บิลที่พี่สร้างไว้จะแสดงที่นี่ค้าบ~~',
    complete: 'เก็บครบแล้ว',
    waitForPayBill: 'บิลที่รอจ่าย',
    completeBill: 'ประวัติบิลที่ปิดแล้ว',
    cretedDate: 'วันที่ {{date}}',
    billInGroup: 'ในกลุ่ม {{name}}',
    perEach: '{{members}} คน / คนละ ฿{{amount}}',
    waitForYouPayBill: 'บิลรอคุณจ่าย',
    waitPay: 'รอจ่าย',
    new: 'ใหม่',
    waitForVerify: 'รอตรวจสอบ',
    billCenterTitle: 'รวมบิลของฉัน~',
    inPrivate: 'แชทส่วนตัว',
    requestInGroup: 'เรียกเก็บเงินในกลุ่ม',
    requestInPrivate: 'เรียกเก็บในแชทส่วนตัว',
    createBill: 'สร้างบิล',
    billWaitForPay: 'บิลที่รอพี่มาจ่าย',
    billYouCreate: 'บิลที่พี่สร้างไว้',
    requestBy: 'เรียกเก็บโดย {{name}}',
  },
  createPrivateBillPage: {
    createBill: 'สร้างบิลเรียกเก็บ',
    inputBillName: 'ใส่ชื่อบิล',
    payIn: 'บิลหมดอายุ:',
    includeMe: 'หารฉันด้วย',
    notIncludeMe: 'ฉันไม่ได้อยู่ในบิลนี้',
    totalMember: 'หาร {{number}} คน',
    requestPer: 'เรียกเก็บคนละ ฿{{number}}',
    requestOne: 'เรียกเก็บ ฿{{number}}',
    requestTotal: 'ยอดเรียกเก็บ',
    requestSummary: 'ยอดรวมบิล',
    requestOneTab: 'เรียกเก็บคนเดียว',
    requestManyTab: 'เรียกเก็บหลายคน',
    requestMember: 'เรียกเก็บ {{numberOfRequestMember}} คน',
  },
  previewPrivateBillPage: {
    shareToFriends: 'ส่งบิลเรียกเก็บ {{number}} คน',
    tooManyBills: 'คุณพี่สร้างบิลได้แค่ {{number}} บิล \nเท่านั้นคร้าบบ~',
    reachAmountLimit:
      'คุณพี่สร้างบิลได้ไม่เกินวันละ {{number}} บาท \nเท่านั้นคร้าบบ~',
    reachLimitAmountPerBill:
      'คุณพี่สร้างบิลได้ไม่เกิน {{number}} บาท \nเท่านั้นคร้าบบ~',
    notePlaceholder: 'ใส่โน๊ตสั้นๆ ถึงเพื่อน',
    noteExceedLimit:
      'ขออภัยค้าบ ขุนทองรองรับข้อความได้สูงสุดไม่เกิน {{number}} ตัวอักษรน้า',
    payBill: 'จ่ายเงิน',
    summaryBill: 'สรุปบิลเรียกเก็บ',
  },
  privateBillSummaryPage: {
    sendAgain: 'ส่งบิลอีกครั้ง',
    waitFriendResponse: 'รอเพื่อนตอบรับ {{number}} คน',
    remove: 'ลบออก',
    editBill: 'แก้ไขบิล',
    complete: 'เสร็จสิ้น',
    waitForResponse: 'รอเพื่อนตอบรับ',
    billWillExpire: 'บิลนี้กำลังจะหมดอายุ',
    expireRetry: 'พี่สามารถส่งบิลอีกครั้ง หรือลบได้เลยหากไม่ใช้',
  },
  groupListPage: {
    allGroup: 'เลือกกรุ๊ปไลน์',
    searchGroup: 'ค้นหากรุ๊ปไลน์',
    subTitle: 'ให้น้องช่วยเก็บเงินที่กรุ๊ปไหนดีค๊าบ~',
    noBillText1: 'ถ้าไม่มีกรุ๊ปที่พี่ต้องการ',
    noBillText2: 'ช่วยเพิ่ม “ขุนทอง” เข้ากรุ๊ปก่อนนะค๊าบ~',
  },
  previewCreateBillPage: {
    shareToGroup: 'ส่งบิลเข้ากลุ่ม',
    seeWhoPaid: 'ดูว่าใครจ่ายเงินแล้ว',
    durationDate: 'วันที่ {{day}}, {{time}}',
    weekDate: 'วัน{{day}}, {{time}}',
  },
  privateBillPaymentSuccessPage: {
    payFor: 'ให้คุณ <span>@{{ownerName}}</span> {{backWord}}',
    complete: 'เรียบร้อย',
    amount: 'จำนวน',
    paidWithCashTitle: 'จ่ายแล้วด้วยเงินสด',
    paidWithCashWaitingTitle: 'รอตรวจสอบจากผู้รับเงิน',
    paidWithSlipTitle: 'จ่ายแล้วยืนยันหลักฐานด้วยสลิป',
    overAmountTitle: 'จ่ายแล้วด้วยสลิป แต่พี่โอนมาเกินนะ',
    underAmountTitle: 'โอนมาไม่ตรงกับยอดที่เรียกเก็บ',
    paidWithSlipErrorType1Title: 'รอผู้รับเงินตรวจสอบสลิป',
    paidWithSlipErrorType2Title: 'โอนมาไม่ตรงกับบัญชีที่เรียกเก็บ',
    overAmount: 'โอนเกินมา',
    underAmount: 'เหลือต้องจ่ายอีก',
    bill: 'บิล',
    withSlip: 'ด้วยสลิป',
    transferAmount: 'จำนวนเงินที่โอนมา',
  },
  deepLinkCreateBill: {
    createNewBill: 'อยากส่งบิลแบบไหน~',
    enterFrom: 'จากช่องทาง',
    enterAmount: 'จำนวนเงิน',
    createGroupBillTitle: 'ส่งในกลุ่มไลน์',
    createGroupBillSubTitle: 'เรียกเก็บเพื่อนในกรุ๊ปไลน์ทางนี้เลย',
    createPrivateBillTitle: 'ส่งแยกในแชทส่วนตัว',
    createPrivateBillSubTitle: 'หารและส่งบิลให้เพื่อนในแชทได้เลย',
    summaryBill: 'สรุปบิล',
  },
  scheduleCarousel: {
    createDate: 'บิลจะถูกสร้าง',
    lastBill: 'กำลังเรียกเก็บบิล',
    everyDay: 'บิลเก็บทุกวันที่',
    everyMonthDay: 'บิลเก็บทุก {{month}} เดือน วันที่',
    everyWeek: 'บิลเก็บทุกสัปดาห์ วัน{{day}}',
    every2Week: 'บิลเก็บทุก 2 สัปดาห์ วัน{{day}}',
  },
};

export default langTh;
